let custom_money_format = document.querySelector('.custom_money_format').dataset.value;
var Shopify = Shopify || {}; Shopify.money_format = custom_money_format; Shopify.formatMoney = function(cents, format) { if (typeof cents == 'string') { cents = cents.replace('.',''); } var value = ''; var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/; var formatString = (format || this.money_format); function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); } function formatWithDelimiters(number, precision, thousands, decimal) { precision = defaultOption(precision, 2); thousands = defaultOption(thousands, ','); decimal   = defaultOption(decimal, '.'); if (isNaN(number) || number == null) { return 0; } number = (number/100.0).toFixed(precision); var parts   = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents   = parts[1] ? (decimal + parts[1]) : ''; return dollars + cents; } switch(formatString.match(placeholderRegex)[1]) { case 'amount': value = formatWithDelimiters(cents, 2); break; case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break; case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break; case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break; } return formatString.replace(placeholderRegex, value); };
function toggleOrderDiscountVisibility() {
  const savingEl = document.querySelector(".block-saving__amount");
  const savingsRow = document.querySelector(".cart-item__savings");

  if (!savingEl || !savingsRow) return;

  // Attribute preference (cus-discount) otherwise text
  let value = savingEl.getAttribute("cus-discount") || savingEl.textContent;

  // Remove currency symbols & spaces → keep only number
  let numericValue = parseFloat(
    value.replace(/[^0-9.-]+/g, "")
  );

  if (!numericValue || numericValue === 0) {
    savingsRow.classList.add("hidden");
  } else {
    savingsRow.classList.remove("hidden");
  }
}

function updateCompareTotal() {
  const cart_compare_elem = document.querySelector( "[data-compare-total]");

  //  SAFETY CHECK
  if (!cart_compare_elem) {
    console.warn('updateCompareTotal skipped: data-original-total not found');
    return;
  }

  const data_original_total =
    cart_compare_elem.getAttribute("data-compare-total");

  if (!data_original_total) return;
  // console.log("Total Comapre price",data_original_total);

  const formattedTotal = formatMoneyNoTrailing(data_original_total);

  const totalCompareEls = document.querySelectorAll(".total_com_price");
  // if (!totalCompareEl) return;
  totalCompareEls.forEach((totalCompareEl)=>{
    totalCompareEl.textContent = formattedTotal;
  });
  
}

function updateFreeShippingUI(cartTotalCents) {
  const shippingBlock = document.querySelector('.cart-shipping__details');
  const shippingLink = shippingBlock?.querySelector('.shipping_link');
  if (!shippingBlock || !shippingLink) return;

  const freeLimit = Number(shippingBlock.dataset.freeLimit);
  const isFreeShipping = cartTotalCents >= freeLimit;
  const country = window.Shopify?.country || 'US';

  /* =========================
     NON-US (always flat rate)
  ========================== */
  if (country !== 'US') {
    shippingBlock.dataset.freeShipping = 'false';
    shippingLink.innerHTML = '$19.95 USD Flat-Rate Shipping'; 
    shippingLink.classList.remove('free-shipping-active');
    return;
  }

  /* =========================
     US logic
  ========================== */
  if (isFreeShipping) {
    shippingBlock.dataset.freeShipping = 'true';
    shippingLink.textContent = 'Free Shipping';
    shippingLink.classList.add('free-shipping-active');
  } else {
    shippingBlock.dataset.freeShipping = 'false';
    shippingLink.textContent = 'Calculated at next step';
    shippingLink.classList.remove('free-shipping-active');
  }
}

function updateCartPageOrderDiscount(cart) {
  let saving = 0;
  let requests = [];

  cart.items.forEach(item => {
    requests.push(
      fetch(`/variants/${item.id}.js`)
        .then(res => res.json())
        .then(variant => {
          if (variant.compare_at_price && variant.compare_at_price > item.original_price) {
            saving +=
              (variant.compare_at_price - item.original_price) *
              item.quantity;
          }
        })
    );
  });

  Promise.all(requests).then(() => {
    saving += cart.total_discount || 0;

    const wrap = document.querySelector('[data-cart-page-discount]');
    if (!wrap) return;

    const amountEl = wrap.querySelector('.block-saving__amount');
    if (!amountEl) return;

    if (saving > 0) {
      const formatted = formatMoneyNoTrailing(saving);
      amountEl.textContent = formatted;
      amountEl.setAttribute('cus-discount', formatted);
      wrap.classList.remove('hidden');
    } else {
      wrap.classList.add('hidden');
      amountEl.textContent = '';
      amountEl.removeAttribute('cus-discount');
    }
  });
}
// Restrict specific product from Non Us customer
  function closeRestrictedPopup() {
    const restrictedPopup = document.querySelector(".custom-non-us-restricted");
    if (restrictedPopup) {
      restrictedPopup.classList.remove("active");
    }
  }
  document.addEventListener("click", function(e) {
    if (e.target.classList.contains("custom-non-us-restricted-popup-full-width-overlay")) {
      closeRestrictedPopup();
    }
  });

  document.addEventListener("click", function(e) {
    if (e.target.closest(".btn-copy-battery")) {
      const specsList = document.querySelectorAll(".battery-specs li");

      let specsText = [];
      specsList.forEach(li => {
        specsText.push(li.textContent.trim());
      });

      const finalText = specsText.join("\n");

      navigator.clipboard.writeText(finalText).then(() => {
        console.log("Battery specs copied");
      });
      closeRestrictedPopup();
    }
  });

  function customNonUsRestricted(){
    const restrictedPopup = document.querySelector(".custom-non-us-restricted");
    // console.log("restrictedPopup",restrictedPopup);
    if(restrictedPopup){
      restrictedPopup.classList.add("active");
      const okayBtn = restrictedPopup.querySelector(".btn-ok");
      if(okayBtn){
        okayBtn.addEventListener('click',function(){
          closeRestrictedPopup();
        })
      }
    }
  }
  document.addEventListener("click", function(e) {
    if (e.target.closest(".close-btn-wrapper")) {
      closeRestrictedPopup();
    }
  });
// Restrict specific product from Non Us customer

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartPageOrderDiscount(cart);
      updateCompareTotal();
    });
});

function updateExtendedWarranty() {
  // Fetch cart data
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let updates = {};
      let relatedProductMap = {};
      let saving = 0;

      // STEP 1: Build a map of main products with _related_product and quantity
      cart.items.forEach(item => {
        if (!item.properties?.['Extended Warranty'] && item.properties?.['_related_product']) {
          relatedProductMap[item.properties['_related_product']] = item.quantity;
        }
      });

      // STEP 2: Check warranties (remove if missing, sync quantity if mismatch)
      cart.items.forEach(item => {
        if (item.properties?.['Extended Warranty'] && item.properties['_related_product']) {
          let relatedKey = item.properties['_related_product'];
          let mainQty = relatedProductMap[relatedKey];

          if (!mainQty) {
            // Remove warranty if main product not found
            updates[item.key] = 0;
          } else if (item.quantity !== mainQty) {
            // Sync warranty quantity with main product
            updates[item.key] = mainQty;
          }
        }

        // STEP 3: Calculate savings
        let variantId = item.id;
        fetch(`/variants/${variantId}.js`)
          .then(res => res.json())
          .then(variant => {
            if (variant.compare_at_price > item.original_price) {
              let line_saving = (variant.compare_at_price - item.original_price) * item.quantity;
              saving += line_saving;
            }

            let formattedSaving = formatMoneyNoTrailing(saving);
            let savingEl = document.querySelector(".cart__footer .block-saving__amount");
            if (savingEl) {
              savingEl.textContent = formattedSaving;          // text update (je tame karto hata)
              savingEl.setAttribute("cus-discount", formattedSaving); // ✅ SAME value attribute ma
            }

            toggleOrderDiscountVisibility();


          })
          .catch(err => console.error("Variant fetch error:", err));
      });

      // STEP 4: Apply updates if needed
      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(res => res.json())
          .then(response => {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { product: response }
              })
            );
            updateCompareTotal();
          })
          .catch(console.error);
      }else{
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));
      }

      // STEP 5: Helper for formatting money
      function formatMoneyNoTrailing(amount) {
        let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
        return formatted.replace(/(\.00|,00)$/, '');
      }
    })
    .catch(err => console.error("Cart fetch error:", err));
}

function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const centsPart = parts[1] ? decimal + parts[1] : "";
    return dollars + centsPart;
  }

  format = format || window.Shopify.money_format;

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return format.replace(placeholderRegex, value);
}


function addToCartPopup_fn(product){
  if (!product) return;
  
  // console.log("add to cart popup function called...");
  const addToCartPopup = document.querySelector(".custom-addtocart-popup");
  addToCartPopup.classList.add("active");

  const bfBadge = addToCartPopup.querySelector(".pdp-bfd-button");
  if (bfBadge) {
    bfBadge.style.display =
      product.compare_at_price && product.compare_at_price > product.price
        ? "flex"
        : "none";
  }
  // console.log("Product",product);

  if (addToCartPopup) {
    // Display currently added items
      addToCartPopup.querySelector(".poup-main-content .image-wrapper img").src = product.featured_image.url;
      addToCartPopup.querySelector(".poup-main-content .title").innerHTML = `<h2>${product.product_title}</h2>`;

      if(product.variant_title){
        addToCartPopup.querySelector(".poup-main-content .variant-title").innerHTML = `${product.variant_title}`;
      }
  
      addToCartPopup.querySelector(".view-cart-btn").setAttribute("disabled","disabled");
      const comparePriceHTML = product.compare_at_price
        ? `<div class="compare-price">${formatMoney(product.compare_at_price, window.Shopify.money_format)}</div>`
        : "";

      const priceHTML = `<div class="price">${formatMoney(product.price, window.Shopify.money_format)}</div>`;

      addToCartPopup.querySelector(".poup-main-content .price-wrapper").innerHTML =
      comparePriceHTML + priceHTML;

      // ADD THIS PART (Discount Percentage)
      let discountPercentHTML = "";

      if (product.compare_at_price && product.compare_at_price > product.price) {
        const discountValue = product.compare_at_price - product.price;
        const discountPercent = Math.round((discountValue / product.compare_at_price) * 100);
        discountPercentHTML = `<span class="discount-percent">${discountPercent}% OFF</span>`;
      }

      addToCartPopup.querySelector(".cst-per").innerHTML = discountPercentHTML;

      fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Optional: show in popup
        const popupCount = addToCartPopup.querySelector(".view-cart-btn");
        if (popupCount) {
          popupCount.textContent = `VIEW CART (${cart.item_count})`;
        }
      })
      .catch((error) => console.error("Cart fetch error:", error));

      addToCartPopup.querySelector(".view-cart-btn").removeAttribute("disabled");

      const closeBtn = addToCartPopup.querySelector(".close-btn-wrapper");
      if(closeBtn){
        closeBtn.addEventListener('click',function(){
          addToCartPopup.classList.remove("active");
        });
      }

      // Close on outside click
      setTimeout(() => {
        const handleOutsideClick = (e) => {
          if (!addToCartPopup.classList.contains("active")) return;

          // Ignore clicks triggered in the cart or on warranty buttons
          if (e.target.closest(".cart__item_wrp") || e.target.closest(".extended-warranty")) return;

          const content = addToCartPopup.querySelector(".poup-main-content");
          const recommendedItems = addToCartPopup.querySelector(".popup-bottom-position");
          if (content && !content.contains(e.target) && !recommendedItems.contains(e.target)) {
            addToCartPopup.classList.remove("active");
            document.removeEventListener("click", handleOutsideClick);
          }
        };

        document.addEventListener("click", handleOutsideClick);
      }, 100);

      setTimeout(()=>{
        const viewCartBtn = document.querySelector(".view-cart-btn");

        viewCartBtn.addEventListener("click", function (e) {
          e.preventDefault();

          // Close the popup
          const addToCartPopup = document.querySelector(".popup-action-content.qq");
          if (addToCartPopup) {
            addToCartPopup.classList.remove("active");
          }

          if (window.innerWidth >= 768) {
            // Desktop: redirect to cart page
            window.location.href = "/cart";
          // new theme.Drawer("header_minicart", "right").open();
          } else {
            // Mobile: open minicart drawer
            setTimeout(() => {
              const minCartTrigger = document.querySelector(".block-mincart .cstm_icon");
              if (minCartTrigger) minCartTrigger.click();
              
            }, 500);
          }
        });
      },1500);


    // Display currently added items

    // Recommended items in cart popup

      const properties = product.properties || {};
      const productKeys = Object.keys(properties).filter(key => key.startsWith("_product"));
      const container = document.querySelector(".recommended-pro-list");
      container.innerHTML = '';

      if (productKeys.length === 0) return;
      const fetchPromises = productKeys.map(key => {
        const handle = properties[key];

        return fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(product => {
            const variant = product.variants[0];

            const image = product.featured_image;
            const title = product.title;
            const url = product.url;
            const description = product.description.replace(/(<([^>]+)>)/gi, "").slice(0, 120);
            const price = (variant.price / 100).toFixed(2);
            const comparePrice = variant.compare_at_price
              ? (variant.compare_at_price / 100).toFixed(2)
              : "";

            const html = `
              <div class="pro-list">
                <div class="image-wrapper">
                  <img src="${image}" alt="${title}" loading="lazy">
                </div>

                <div class="data-wrapper">
                  <div class="details-left">
                    <h2 class="title">
                      <a href="${url}">${title}</a>
                    </h2>

                    <p class="additional-cts-text">${description}</p>

                    <div class="price-wrapper">
                      ${comparePrice ? `<div class="compare-price">$${comparePrice}</div>` : ""}
                      <div class="price">$${price}</div>
                    </div>

                    <div class="product-info"></div>
                  </div>

                  <div class="action-btn-right">
                    <button class="add-pro-btn" data-variant-id="${variant.id}">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="20" cy="20" r="20" fill="#87F614"/>
                          <path d="M12.5 18.75H27.5V21.25H12.5V18.75Z" fill="black"/>
                          <path d="M21.25 12.5V27.5H18.75V12.5L21.25 12.5Z" fill="black"/>
                      </svg>
                    </button>

                    <button class="already-added-pro-btn hide">
                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="20" cy="20" r="19.5" stroke="white"/>
                          <path d="M13.6428 18.1694L19.83 24.3566L18.0622 26.1244L11.875 19.9372L13.6428 18.1694Z" fill="#87F614"/>
                          <path d="M28.6688 15.5178L18.0622 26.1244L16.2944 24.3566L26.901 13.75L28.6688 15.5178Z" fill="#87F614"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            `;

            container.insertAdjacentHTML("beforeend", html);
          })
          .catch(err => {
            console.error("Product fetch failed:", handle, err);
          });     
      });

      Promise.all(fetchPromises).then(() => {

        const productList = container.querySelectorAll(".pro-list");
        if (productList.length) {
          productList.forEach(function (productItem) {
            const add_btn = productItem.querySelector(".add-pro-btn");
            if (!add_btn) return;

            add_btn.addEventListener("click", function (event) {
              event.preventDefault();

              const pro_id = this.getAttribute("data-variant-id");
              if (!pro_id) return;

              this.classList.add("btn--loading");
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: parseInt(pro_id, 10),
                  quantity: 1,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                  const product = data;

                  document.dispatchEvent(
                    new CustomEvent("ajaxProduct:added", {
                      detail: {
                        product: product,
                      },
                    })
                  );
                  this.classList.add("hide");
                  productItem.querySelector(".already-added-pro-btn").classList.remove("hide");
                  this.classList.remove("btn--loading");
                })
                .catch((err) => {
                  console.error("Add to cart error:", err);
                  this.classList.remove("btn--loading");
                });
            });
          });
        }
      });
     
     
    // Recommended items in cart popup
   
  }

 


}

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  vimeoReady: false,
  stickyHeader: false,
  youTubeReady: false,
  vimeoLoading: false,
  hasLocalStorage: true,
  hasSessionStorage: true,
  rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};

theme.recentlyViewedIds = [];

(function () {
  "use strict";

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener("transitionend", removeClass);

      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }

      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace
          ? "focusout." + options.namespace
          : "focusout",
        keydown: options.namespace
          ? "keydown." + options.namespace
          : "keydown.handleFocus",
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";

      if (options.container) {
        options.container.removeAttribute("tabindex");
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add("lock-scroll");
      el.on("touchmove" + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove("lock-scroll");
      var el = element ? element : document.documentElement;
      el.off("touchmove" + namespace);
    },
  };

  theme.cookies = {
    getCookie: function (cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    var superScript = false;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
      if (typeof images === "string") {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return "680x";
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }

      if (size === "master") {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      } else {
        return null;
      }
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    return {
      preload: preload,
      loadImage: loadImage,
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
    };
  })();

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: "link",
      script: "script",
    };

    var status = {
      requested: "requested",
      loaded: "loaded",
    };

    var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

    var libraries = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: types.script,
      },
      vimeo: {
        tagId: "vimeo-api",
        src: "https://player.vimeo.com/api/player.js",
        type: types.script,
      },
      shopifyXr: {
        tagId: "shopify-model-viewer-xr",
        src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
        type: types.script,
      },
      modelViewerUi: {
        tagId: "shopify-model-viewer-ui",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement("script");
      tag.src = library.src;
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement("link");
      tag.href = library.src;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll(".rte table").forEach((table) => {
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("table-wrapper");
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("video-wrapper");
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll(".rte a img").forEach((img) => {
      img.parentNode.classList.add("rte__image");
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      this.container
        .querySelectorAll(this.singleOptionSelector)
        .forEach((el) => {
          el.addEventListener("change", this._onSelectChange.bind(this));
        });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container
          .querySelectorAll(this.singleOptionSelector)
          .forEach((el) => {
            var type = el.getAttribute("type");

            if (type === "radio" || type === "checkbox") {
              if (el.checked) {
                result.push({
                  value: el.value,
                  index: el.dataset.index,
                });
              }
            } else {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function (option) {
            if (match) {
              match = variant[option.index] === option.value;
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function () {
        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variant: variant,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: variant,
            },
          })
        );

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        console.log("variant chnage",variant);
        if(variant){
         let sticky_variant_title = document.querySelector('.sticky-add-to-cart-btn .select-varient-combo');
         if(sticky_variant_title){
          sticky_variant_title.textContent = variant.title;
         }
          const priceEl = document.querySelector('.sticky-add-to-cart-btn [data-product-price] .formatted_price');
          if (priceEl) {
            priceEl.innerHTML = Shopify.formatMoney(
              variant.price
            );
          }

          // Update compare at price
          const comparePriceWrap = document.querySelector('.sticky-add-to-cart-btn [data-product-price-wrap]');
          const comparePriceEl = document.querySelector('.sticky-add-to-cart-btn [data-compare-price] .formatted_price');

          if (comparePriceEl && comparePriceWrap) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              comparePriceEl.innerHTML = Shopify.formatMoney(
                variant.compare_at_price
              );

              comparePriceWrap.style.display = '';
            } else {
              comparePriceWrap.style.display = 'none';
            }
          }
         let fp_compare_at_price = document.querySelector(".fp-compare-at-price");
         let fp_main_price = document.querySelector(".fp-main-price");
         let fp_discount_percentages = document.querySelectorAll(".fp-discount-percentage");
         if(variant.compare_at_price){
          fp_compare_at_price.classList.remove("hide");
          fp_compare_at_price.innerHTML = Shopify.formatMoney(variant.compare_at_price)
          if (variant.compare_at_price > variant.price) {
            let discount_percentage = '';
            discount_percentage = Math.round(
              ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
            ) + '%';
            fp_discount_percentages.forEach((fp_discount_percentage)=>{
              fp_discount_percentage.innerText = discount_percentage;
              fp_discount_percentage.closest('.fp-discount-tagline')?fp_discount_percentage.closest('.fp-discount-tagline').classList.remove("hide"):'';
            })
          }
         }else{
          fp_compare_at_price.classList.add("hide");
          fp_discount_percentages.forEach((fp_discount_percentage)=>{
            fp_discount_percentage.closest('.fp-discount-tagline')?fp_discount_percentage.closest('.fp-discount-tagline').classList.add("hide"):'';
          })
         }
         fp_main_price.innerHTML = Shopify.formatMoney(variant.price);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (
          !variant.featured_image ||
          variantImage.src === currentVariantImage.src
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantImageChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        console.log("variant price",variant.price);
        if (
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value =
          variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container
          .querySelector(this.originalSelectorId)
          .dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady().then(function () {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent("vimeoReady"));
    });
  };

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false,
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
        document.addEventListener("vimeoReady", this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector("iframe");
        this.iframe.setAttribute("tabindex", "-1");

        this.videoPlayer.setMuted(true);

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
  };

  /*============================================================================
  YouTube SDK method
  Parameters:
    - player div id (required)
    - arguments
    - videoId (required)
    - videoParent (selector, optional for section loading state)
    - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      };

      this.options = Object.assign({}, defaults, options);
      // console.log(this.options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document
            .getElementById(this.divId)
            .closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === "sound") {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("youtubeSdk");
        document.addEventListener("youTubeReady", this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute("tabindex", "-1");

        if (this.options.style !== "sound") {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.playVideo === "function"
        ) {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.pauseVideo === "function"
        ) {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return YouTube;
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true) {
        if (searchParams) this.appendPreservedParams(searchParams);

        const sectionRenders = this.sections.map((section) => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = (cachedSection) => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(searchParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(
          `[AjaxRenderer] rendering from cache: url=${cachedSection.url}`
        );
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch((err) => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`
        );

        const newDom = new DOMParser().parseFromString(html, "text/html");
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === "string") {
            document.getElementById(section.nodeId).innerHTML =
              newDom.getElementById(section.nodeId).innerHTML;
          } else {
            section.nodeId.forEach((id) => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach((paramName) => {
          const param = new URLSearchParams(window.location.search).get(
            paramName
          );

          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          "",
          `${window.location.pathname}${searchParams && "?".concat(searchParams)
          }`
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  theme.Cart = {
    getCart: function () {
      var url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());

      url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";

      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then(function (response) {
        return response.text();
      });
    },

    changeItem: function (key, qty) {
      return this._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(function (cart) {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          attributes: {
            [key]: theme.Cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          note: theme.Cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
          attribute = "";
        }
      }
      return attribute.trim();
    },
  };

  /*============================================================================
    HeaderCart
  ==============================================================================*/
  theme.HeaderCart = (function () {
    var selectors = {
      cart: "[data-header-cart]",
      cartTrigger: "[data-header-cart-trigger]",

      closeBtn: ".js-close-header-cart",
      noteBtn: "[data-cart-notes]",
    };

    var classes = {
      hidden: "hide",
    };

    var config = {
      cartOpen: false,
      namespace: ".cart-header",
    };

    function HeaderCart() {
      this.wrapper = document.querySelector(selectors.cart);
      if (!this.wrapper) {
        return;
      }
      this.trigger = document.querySelector(selectors.cartTrigger);
      this.noteBtn = this.wrapper.querySelector(selectors.noteBtn);
      this.form = this.wrapper.querySelector("form");

      // Close header cart
      document.addEventListener("MobileNav:open", this.close.bind(this));
      document.addEventListener("ModalOpen", this.close.bind(this));

      this.init();
    }

    HeaderCart.prototype = Object.assign({}, HeaderCart.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.querySelectorAll(selectors.closeBtn).forEach((btn) => {
          btn.addEventListener(
            "click",
            function () {
              this.close();
            }.bind(this)
          );
        });

        if (this.noteBtn) {
          this.noteBtn.addEventListener(
            "click",
            function () {
              this.noteBtn.classList.toggle("is-active");
              this.wrapper
                .querySelector(".cart__note")
                .classList.toggle("hide");
            }.bind(this)
          );
        }

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            this.cartForm.buildCart();
            if (!config.cartOpen) {
              this.open();
            }
          }.bind(this)
        );

        // Dev-friendly way to open cart
        document.addEventListener("cart:open", this.open.bind(this));
        document.addEventListener("cart:close", this.close.bind(this));
      },

      open: function (evt) {
        if (evt) {
          evt.preventDefault();
        }

        theme.a11y.lockMobileScrolling(config.namespace);

        // Esc closes cart popup
        window.on(
          "keyup" + config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        document.dispatchEvent(new CustomEvent("CartDrawer:open"));
        document.dispatchEvent(new CustomEvent("drawerOpen"));

        // Clicking out of cart closes it. Timeout to prevent immediate bubbling
        setTimeout(
          function () {
            window.on(
              "click" + config.namespace,
              function (evt) {
                this.close(evt);
              }.bind(this)
            );
          }.bind(this),
          0
        );

        config.cartOpen = true;
      },

      close: function (evt) {
        // Do not close if click event came from inside drawer
        if (
          evt &&
          evt.target.closest &&
          evt.target.closest(".site-header__drawer")
        )
          return;

        if (!config.cartOpen) {
          return;
        }

        // If custom event, close without transition
        if (evt && evt.type === "MobileNav:open") {
          this.wrapper.classList.remove("is-active");
        } else {
          theme.utils.prepareTransition(
            this.wrapper,
            function () {
              this.wrapper.classList.remove("is-active");
            }.bind(this)
          );
        }

        window.off("keyup" + config.namespace);
        window.off("click" + config.namespace);

        theme.a11y.unlockMobileScrolling(config.namespace);

        config.cartOpen = false;
      },
    });

    return HeaderCart;
  })();

  theme.QuickAdd = (function () {

    var selectors = {
      quickAddBtn: "[data-quick-addbutton]",
      quickLoadForm: "[data-quick-loadform]",
      quickLoadHolder: "#QuickLoadHolder",
    };

    var modal;
    var modalInitailized = false;

    function QuickAdd(container) {
      if (!container) {
        return;
      }

      if (!theme.settings.quickAdd) {
        return;
      }

      this.container = container;
      this.init();
    }

    QuickAdd.prototype = Object.assign({}, QuickAdd.prototype, {
      // init: function () {
      //   // When a single variant, auto add it to cart
      //   var quickAddBtns = this.container.querySelectorAll(
      //     selectors.quickAddBtn
      //   );
      //   if (quickAddBtns) {
      //     quickAddBtns.forEach((btn) => {
      //       btn.addEventListener("click", this.addToCart.bind(this));
      //     });
      //   }

      //   // Button loads form when 1+ variants
      //   var quickLoadForms = this.container.querySelectorAll(
      //     selectors.quickLoadForm
      //   );
      //   console.log("quickLoadForms",quickLoadForms);

      //   if (quickLoadForms.length) {
      //     this.quickLoadHolder = document.querySelector(
      //       selectors.quickLoadHolder
      //     );
      //     if (!modalInitailized) {
      //       modal = new theme.Modals("QuickLoadModal", "quick-add");
      //       modalInitailized = true;

      //       // Empty cart form when closed
      //       document.addEventListener(
      //         "modalClose.QuickAddModal",
      //         function () {
      //           setTimeout(
      //             function () {
      //               this.quickLoadHolder.innerHTML = "";
      //             }.bind(this),
      //             300
      //           );
      //         }.bind(this)
      //       );
      //     }

      //     quickLoadForms.forEach((btn) => {
      //       btn.addEventListener("click", this.loadQuickLoadForm.bind(this));
      //     });
      //   }
      // },

      init: function () {
        //  Attach single variant quick add (direct add to cart)
        var quickAddBtns = document.querySelectorAll(selectors.quickAddBtn);
        if (quickAddBtns && quickAddBtns.length) {
          quickAddBtns.forEach((btn) => {
            btn.addEventListener("click", this.addToCart.bind(this));
          });
        }

        //  Initialize modal once globally
        if (!modalInitailized) {
          modal = new theme.Modals("QuickLoadModal", "quick-add");
          modalInitailized = true;

          document.addEventListener("modalClose.QuickAddModal", () => {
            setTimeout(() => {
              const holder = document.querySelector(selectors.quickLoadHolder);
              if (holder) holder.innerHTML = "";
            }, 300);
          });
        }

        // Attach click event to all quick load form buttons globally
        document.querySelectorAll(selectors.quickLoadForm).forEach((btn) => {
          btn.addEventListener("click", (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            const gridItem = btn.closest("[data-product-card]");
            if (!gridItem) {
              console.warn("No [data-product-card] found for button:", btn);
              return;
            }

            // prevent double popup
            if (btn.classList.contains("btn--loading")) return;
            btn.classList.add("btn--loading");

            // Create QuickAdd instance for this product
            const quickAddInstance = new QuickAdd(gridItem);
            quickAddInstance.quickLoadHolder = document.querySelector(selectors.quickLoadHolder);
            quickAddInstance.loadQuickLoadForm(evt);

            setTimeout(() => btn.classList.remove("btn--loading"), 1500);
          });
        });
      },
      
      addToCart: function (evt) {
        const _this = this;
        let button = evt.currentTarget;
        let variantId = button.dataset.id;

        button.classList.add("btn--loading");

        let productId = button.dataset.productId;
        // var data = {
        //   items: [
        //     {
        //       id: productId,
        //       quantity: 1,
        //     },
        //   ],
        // };


        const countryCode = document.documentElement.getAttribute('country');
        if (countryCode !== 'US') {
          if(productId == '6078153326755'){
            customNonUsRestricted();
            return;
          }
        }

        console.log("added to cart...................");

        let itemData = {
          id: variantId,
          quantity: 1,
        };

        // Only for Quick Add
        if (button.hasAttribute("data-quick-addbutton")) {
          let properties = {};

          // Step 3: Read from the button’s dataset
          if (button.dataset.relatedProduct) {
            properties["_related_product"] = button.dataset.relatedProduct;
          }

          if(button.dataset.product1){
            properties["_product_1"] = button.dataset.product1;
          }

          if(button.dataset.product2){
            properties["_product_2"] = button.dataset.product2;
          }

          // Add to item only if exists
          if (Object.keys(properties).length > 0) {
            itemData.properties = properties;
          }
        }

        // Build payload
        const data = {
          items: [itemData],
        };

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422 || data.status === "bad_request") {
              } else {
                var product = data;
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      product: product,
                      addToCartBtn: button,
                    },
                  })
                );
                fetch(`/products/${product.handle}.js`)
                .then(res => res.json())
                .then(productData => {
                  // console.log("productData",productData);
                });

                if (product.items && Array.isArray(product.items)) {
                  product = product.items[0]; // get the first added item
                }

                // Now product is guaranteed correct
                fetch(`/variants/${product.id}.js`)
                  .then(res => res.json())
                  .then(variantData => {
                    product.price = variantData.price;
                    product.compare_at_price = variantData.compare_at_price;
                    button.classList.remove("btn--loading");
                    addToCartPopup_fn(product);
                    
                  })
                  .catch(err => {
                    console.error("Error fetching variant details:", err);
                    button.classList.remove("btn--loading");
                    addToCartPopup_fn(product);
                  });
                  
                let productobj = data.items[0];
                let variantId = productobj.id;

                setTimeout(() => {
                  let warrantyBtn = document.querySelector(
                    `.cart__item_wrp[data-id="${variantId}"] .extended-warranty[data-extended-submit]`
                  );

                  if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
                    warrantyBtn.click();
                  }
                }, 2000);
                updateExtendedWarranty();
              }
            }.bind(this)
          );
      },

      loadQuickLoadForm: function (evt) {
        this.quickLoadHolder.innerHTML = "";        
       const button_dev = evt.currentTarget;            
        button_dev.classList.add("btn--loading");
          setTimeout(() => {
            button_dev.classList.remove("btn--loading");
          }, 1000);
        var gridItem = evt.currentTarget.closest("[data-product-card]");
        var handle = gridItem.getAttribute("data-product-handle");
        var productId = gridItem.getAttribute("data-product-id");
        var url = theme.routes.home + "/products/" + handle + "?view=form";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
         // setTimeout(() => {
         //      evt.currentTarget.classList.remove("btn--loading")
         //  }, "5000");
            function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var html = doc.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              );

              this.quickLoadHolder.append(html);
              // Register product template inside modal
              theme.sections.register(
                "product",
                theme.Product,
                this.quickLoadHolder
              );

              // if (Shopify && Shopify.PaymentButton) {
              // 	Shopify.PaymentButton.init();
              // }

              window.dispatchEvent(
                new CustomEvent("quickadd:loaded:" + productId)
              );

              document.dispatchEvent(
                new CustomEvent("quickadd:loaded", {
                  detail: {
                    productId: productId,
                    handle: handle,
                  },
                })
              );
              modal.open();
            }.bind(this)
     
          );
      },
    });

    return QuickAdd;
  })();

  theme.QuickShop = (function () {
    var loadedIds = [];
    var selectors = {
      product: "[data-product-card]",
      triggers: "[data-quick-shopbutton]",
      modalContainer: "#ProductModals",
    };

    function QuickShop(container) {
      if (!theme.settings.quickView) {
        return;
      }

      this.container = container;
      this.init();
    }

    function getData(el) {
      return {
        id: el.dataset.productId,
        handle: el.dataset.productHandle,
      };
    }

    function productMouseover(evt) {
      var el = evt.currentTarget;

      // No quick view on mobile breakpoint
      if (theme.config.bpSmall) {
        return;
      }

      // No product or onboarding content, bail
      if (!el || !el.dataset.productId) {
        return;
      }

      var data = getData(el);
      el.removeEventListener("mouseover", productMouseover);

      preloadProductModal(data);
    }

    function preloadProductModal(data) {
      var modals = document.querySelectorAll(
        '.modal--quick-shop[data-product-id="' + data.id + '"]'
      );

      if (!modals.length) {
        return;
      }

      // If already loaded, no need to refetch info
      if (loadedIds.indexOf(data.id) > -1) {
        removeDuplicateModals(modals);
        enableTriggers(data);
      } else {
        // Move modal to storage element so animations work regardless
        // of where original markup is. Will also remove duplicates.
        moveModal(modals);

        var holder = document.getElementById("QuickShopHolder-" + data.handle);
        var url =
          theme.routes.home + "/products/" + data.handle + "?view=modal";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var div = doc.querySelector(
              '.product-section[data-product-handle="' + data.handle + '"]'
            );

            if (!holder) {
              return;
            }

            holder.append(div);

            // Register product template inside quick view
            theme.sections.register("product", theme.Product, holder);

            // Register collapsible elements
            theme.collapsibles.init();

            // Register potential video modal links (when video has sound)
            theme.videoModal();

            // There may be multiple triggers for the same modal, so enable them all
            enableTriggers(data);
          });
      }

      // Add ID to global array so we don't double-load
      loadedIds.push(data.id);
    }

    function moveModal(modals) {
      var el = modals[0];
      if (!el) {
        return;
      }

      // If we have multiple modals, keep the first and remove all the rest
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (i > 0) {
            m.remove();
          }
        });
      }

      var container = document.querySelector(selectors.modalContainer);
      container.appendChild(el);
    }

    // Remove any modal not already in #ProductModals
    function removeDuplicateModals(modals) {
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (!m.closest("#ProductModals")) {
            m.remove();
          }
        });
      }
    }

    function enableTriggers(data) {
      // Setup quick view modal
      var modalId = "QuickShopModal-" + data.id;
      var name = "quick-modal-" + data.id;
      new theme.Modals(modalId, name);

      var triggers = document.querySelectorAll(
        selectors.triggers + '[data-handle="' + data.handle + '"]'
      );

      if (!triggers.length) {
        return;
      }

      triggers.forEach((trigger) => {
        trigger.classList.remove("quick-product__btn--not-ready");
      });
    }

    QuickShop.prototype = Object.assign({}, QuickShop.prototype, {
      init: function () {
        var products = this.container.querySelectorAll(selectors.product);

        if (!products.length) {
          return;
        }

        products.forEach((product) => {
          product.addEventListener("mouseover", productMouseover);
        });
      },
    });

    return QuickShop;
  })();

/*============================================================================
CartForm
- Prevent checkout when terms checkbox exists
- Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
theme.CartForm = (function () {
  var selectors = {
    products: "[data-products]",
    discounts: "[data-discounts]",
    savings: "[data-savings]",
    subTotal: "[data-subtotal]",
    qtySelector: ".js-qty__wrapper",
    devdiscount: "[data-dev-discount]",
    cartBubble: ".cart-link__bubble",
    cartNote: '[name="note"]',
    termsCheckbox: ".cart__terms-checkbox",
    checkoutBtn: ".btn-cart__checkout",
    progressBar: "[data-progress-selector]",
  };

  var classes = {
    btnLoading: "btn--loading",
  };

  var config = {
    requiresTerms: false,
  };

  function CartForm(form) {
    if (!form) {
      return;
    }

    this.form = form;
    this.wrapper = form.parentNode;

    this.location = form.dataset.location;
    this.namespace = ".cart-" + this.location;
    this.products = form.querySelector(selectors.products);
    this.submitBtn = form.querySelector(selectors.checkoutBtn);
    this.discounts = form.querySelector(selectors.discounts);
    this.savings = form.querySelector(selectors.savings);
    this.subtotal = form.querySelectorAll(selectors.subTotal);
    this.progressSelect = form.querySelectorAll(selectors.progressBar);
    this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
    this.noteInput = form.querySelector(selectors.cartNote);
    this.devdiscount = form.querySelector(selectors.devdiscount);

    if (this.termsCheckbox) {
      config.requiresTerms = true;
    }

    this.init();
  }

  CartForm.prototype = Object.assign({}, CartForm.prototype, {
    init: function () {
      this.initQtySelectors();
      this.initDeleteProduct();
      // DISABLED FOR CONVERSION FIX
      this.addExtendeWarranty();

      document.addEventListener(
        "cart:quantity" + this.namespace,
        this.quantityChanged.bind(this)
      );
      document.addEventListener(
        "cart:delete" + this.namespace,
        this.deleteProduct.bind(this)
      );
      this.form.on("submit" + this.namespace, this.onSubmit.bind(this));

      if (this.noteInput) {
        this.noteInput.addEventListener("change", function () {
          var newNote = this.value;
          theme.Cart.updateNote(newNote);
        });
      }

      document.addEventListener(
        "cart:build",
        function () {
          this.buildCart();
        }.bind(this)
      );
    },

    reInit: function () {
      this.initQtySelectors();
      this.initDeleteProduct();
      // DISABLED FOR CONVERSION FIX
      this.addExtendeWarranty();
    },

    onSubmit: function (evt) {
      this.submitBtn.classList.add(classes.btnLoading);

      if (config.requiresTerms) {
        if (this.termsCheckbox.checked) {
          // continue to checkout
        } else {
          this.submitBtn.classList.remove(classes.btnLoading);
          this.form.querySelector(".text-label__terms").style =
            "border-color: #d41010";
          evt.preventDefault();
          return false;
        }
      }
    },
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        return {
          items: doc.querySelector(".cart__items"),
          discounts: doc.querySelector(".cart-discounts"),
          progress: doc.querySelector("[data-progress-selector]"),
          devdiscount: doc.querySelector("[data-dev-discount]"),
        };
      },

      buildCart: function () {
        theme.Cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
       
      },

      cartMarkup: function (html) {
        
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var savings = items.dataset.cartSavings;
        var subtotal = items.dataset.cartSubtotal;
        //var discountTotal = items.dataset.discountTotal;        
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
        // this.updateCartdevdiscount(markup.devdiscount);
        if (count > 0) {
          this.wrapper.classList.remove("is-empty");
        } else {
          this.wrapper.classList.add("is-empty");
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = "";
        this.products.append(items);

        // Update subtotal - with decimal pricing with ex. Rs, 1200.00
        // this.subtotal.forEach((subItem) => {
        //   console.log("subItem",subItem);
        //   subItem.innerHTML = theme.Currency.formatMoney(
        //     subtotal,
        //     theme.settings.moneyFormat
        //   );
        // });

        // Update subtotal - Without decimal pricing with ex. Rs, 1200
        this.subtotal.forEach((subItem) => {
          let formattedPrice = theme.Currency.formatMoney(
            subtotal,
            theme.settings.moneyFormat
          );

          // Remove trailing .00
          formattedPrice = formattedPrice.replace(/\.00$/, '');

          subItem.innerHTML = formattedPrice;
        });

        var progressHtml = markup.progress.innerHTML;
        var messageHtml =
        markup.progress.querySelector("[data-message]").innerHTML;           
        if(document.querySelector("[data-message-bottom]")){
          document.querySelector("[data-message-bottom]").innerHTML =messageHtml;
        }
        if(document.querySelector("[data-progress-selector]")){
        document.querySelector("[data-progress-selector]").innerHTML =  progressHtml;  
        }
        
        // const shippingLink = document.querySelector(".text-link__shipping");

        // shippingLink.classList.remove("hide");
        // if (subtotal > 14900) {
        //   shippingLink.classList.add("hide");
        // }

        this.reInit();

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },       
      updateCartDiscounts: function (markup) {
       
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = "";
        this.discounts.append(markup);
      },
      updateCartdevdiscount: function (markup) {        
        if (!this.devdiscount) {
          return;
        }
        this.devdiscount.innerHTML = "";
        this.devdiscount.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      initDeleteProduct: function () {
        this.form.querySelectorAll("[data-remove-product]").forEach((el) => {
          var selector = new theme.DeleteProduct(el, {
            namespace: this.namespace,
            isCart: true,
            key: el.dataset.key,
          });
        });
      },

      quantityChanged: function (evt) {
        console.log("QUANTITY CHANGED CALL");
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add("is-loading");
        }

        theme.Cart.changeItem(key, qty)
          .then(
            function (cart) {
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              // this.buildCart();

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) { });
      },

      deleteProduct: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key) {
          return;
        }

        theme.Cart.changeItem(key, qty)
          .then(
            function (cart) {
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              this.buildCart();

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
              checkaddon_product();
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) { });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML =
          theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        // console.log("theme.settings.moneyFormat",theme.settings.moneyFormat);
        if (!this.savings) {
          return;
        }
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
          this.savings.closest('.cart-item__savings').classList.remove("hide");
          this.savings.innerHTML = amount;
        } else {
          this.savings.closest('.cart-item__savings').classList.add("hide");
        }
      },

      // addExtendeWarranty: function () {
      //   let buttonExtendedWarranty = document.querySelectorAll('[data-extended-submit]');
      //   buttonExtendedWarranty.forEach((element) => {
      //     element.addEventListener('click', (e) => {
      //       e.preventDefault();
      //       let productID = element.dataset.product;
      //       let productProperties = element.dataset.parentProduct;
      //       let productQuantity = element.dataset.parentQuantity;
      //       let formData = {
      //         'items': [{
      //           'id': productID,
      //           'quantity': productQuantity,
      //           'properties': {
      //             'Extended Warranty': productProperties
      //           }
      //         }]
      //       };

      //       fetch(theme.routes.cartAdd, {
      //         method: "POST",
      //         body: JSON.stringify(formData),
      //         credentials: "same-origin",
      //         headers: {
      //           'Content-Type': 'application/json'
      //         }
      //       })
      //         .then(response => {
      //           console.log(response);
      //           document.dispatchEvent(
      //             new CustomEvent("ajaxProduct:added", {
      //               detail: {
      //                 product: response,
      //               },
      //             })
      //           );
      //         })
      //         .catch((error) => {
      //           console.log(error);
      //         })

      //     });
      //   });
      // },

    //  addExtendeWarranty: function () {

    //   let buttonExtendedWarranty = document.querySelectorAll('.extended-warranty[data-extended-submit]');

    //   // Get cart on page load
    //   fetch('/cart.js')
    //     .then(res => res.json())
    //     .then(cart => {
    //       buttonExtendedWarranty.forEach((btn) => {
    //         let warrantyVariantID = parseInt(btn.dataset.product);
    //         let parentProductHandle = btn.dataset.parentProduct; // or parent ID
    //         let parentQuantity = parseInt(btn.dataset.parentQuantity);
    //         let parentTitle = btn.dataset.parentTitle;

    //         // Check if warranty for this specific parent product exists
    //         let matchingWarranty = cart.items.find(item => {
    //           return item.id == warrantyVariantID &&
    //                 item.properties &&
    //                 item.properties['Extended Warranty'] == parentProductHandle;
    //         });

    //         btn.dataset.inCart = matchingWarranty ? "true" : "false";

    //         btn.addEventListener('click', (e) => {
    //           e.preventDefault();

    //           if (btn.dataset.inCart === "true") {
    //             // --- Remove ONLY this warranty ---
    //             if (matchingWarranty) {
    //               let formData = { updates: { [matchingWarranty.key]: 0 } };
    //               fetch('/cart/update.js', {
    //                 method: "POST",
    //                 body: JSON.stringify(formData),
    //                 headers: { 'Content-Type': 'application/json' }
    //               })
    //               .then(res => res.json())
    //               .then(response => {
    //                 btn.dataset.inCart = "false";
    //                 btn.closest(".cart__item_wrp").querySelector(".cart__item")
    //                   .classList.remove("has-extended-product");
    //                 document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
    //               })
    //               .catch(console.error);
    //             }
    //           } else {
    //             // --- Add warranty for THIS parent product ---
    //             let formData = {
    //               items: [{
    //                 id: warrantyVariantID,
    //                 quantity: parentQuantity,
    //                 properties: {
    //                   'Extended Warranty': parentProductHandle,
    //                   '_related_product' : warrantyVariantID + "_" + parentTitle
    //                 }
    //               }]
    //             };

    //             console.log("formData",formData);

    //             fetch('/cart/add.js', {
    //               method: "POST",
    //               body: JSON.stringify(formData),
    //               headers: { 'Content-Type': 'application/json' }
    //             })
    //             .then(res => res.json())
    //             .then(response => {

    //               console.log("product added successfully..");
    //               btn.dataset.inCart = "true";
    //               btn.closest(".cart__item_wrp").querySelector(".cart__item")
    //                 .classList.add("has-extended-product");
    //               document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
    //             })
    //             .catch(console.error);
    //           }
    //         });
    //       });
    //     })
    //     .catch(console.error);
    // },

    addExtendeWarranty: function () {
      const buttonExtendedWarranty = document.querySelectorAll(
        '.extended-warranty[data-extended-submit]'
      );

       // Get cart on page load
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          buttonExtendedWarranty.forEach((btn) => {

            // Prevent duplicate event binding
            if (btn.dataset.bound === "true") return;
            btn.dataset.bound = "true";

            const warrantyVariantID = parseInt(btn.dataset.product, 10);
            const parentProductHandle = btn.dataset.parentProduct;
            const parentQuantity = parseInt(btn.dataset.parentQuantity, 10);
            const parentTitle = btn.dataset.parentTitle;

            // Check if warranty already exists for this parent product
            let matchingWarranty = cart.items.find(item =>
              item.id === warrantyVariantID &&
              item.properties &&
              item.properties['Extended Warranty'] === parentProductHandle
            );

            btn.dataset.inCart = matchingWarranty ? "true" : "false";

            btn.addEventListener('click', (e) => {
              e.preventDefault();
              // console.log("Btn clicked...");

              // Prevent double click
              if (btn.classList.contains('is-processing')) return;
              btn.classList.add('is-processing');

              // ================= REMOVE WARRANTY =================
              if (btn.dataset.inCart === "true") {
                if (!matchingWarranty) {
                  btn.classList.remove('is-processing');
                  return;
                }

                const formData = {
                  updates: {
                    [matchingWarranty.key]: 0
                  }
                };

                fetch('/cart/update.js', {
                  method: "POST",
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(formData)
                })
                  .then(res => res.json())
                  .then(() => {
                    btn.dataset.inCart = "false";
                    btn.closest(".cart__item_wrp")
                      ?.querySelector(".cart__item")
                      ?.classList.remove("has-extended-product");

                     document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail: {}}));

                    setTimeout(()=>{
                      updateCompareTotal();
                    },1000);

                    // if(document.body.classList.contains("template-cart")){
                    //   location.reload();
                    // }
                  })
                  .catch(console.error)
                  .finally(() => btn.classList.remove('is-processing'));

              } 
              // ================= ADD WARRANTY =================
              else {
                const formData = {
                  items: [{
                    id: warrantyVariantID,
                    quantity: parentQuantity,
                    properties: {
                      'Extended Warranty': parentProductHandle,
                      '_related_product': `${warrantyVariantID}_${parentTitle}`
                    }
                  }]
                };

                fetch('/cart/add.js', {
                  method: "POST",
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(formData)
                })
                  .then(res => res.json())
                  .then(response => {
                    btn.dataset.inCart = "true";
                    btn.closest(".cart__item_wrp")
                      ?.querySelector(".cart__item")
                      ?.classList.add("has-extended-product");

                    document.dispatchEvent(
                      new CustomEvent("ajaxProduct:added", {
                        detail: { product: response }
                      })
                    );

                    setTimeout(()=>{
                      updateCompareTotal();
                    },1000);

                    if(document.body.classList.contains("template-cart")){
                      location.reload();
                    }
                  })
                  .catch(console.error)
                  .finally(() => btn.classList.remove('is-processing'));
              }
            });
          });
        })
        .catch(console.error);
    },


      // addExtendeWarranty: function () {
      //   let buttonExtendedWarranty = document.querySelectorAll('.extended-warranty[data-extended-submit]');

      //   // Get cart on page load
      //   fetch('/cart.js')
      //     .then(res => res.json())
      //     .then(cart => {
      //       buttonExtendedWarranty.forEach((btn) => {
      //         // Prevent duplicate event binding
      //         if (btn.dataset.bound === "true") return;
      //         btn.dataset.bound = "true";

      //         let warrantyVariantID = parseInt(btn.dataset.product);
      //         let parentProductHandle = btn.dataset.parentProduct;
      //         let parentQuantity = parseInt(btn.dataset.parentQuantity);
      //         let parentTitle = btn.dataset.parentTitle;

      //         // Check if warranty for this specific parent product exists
      //         let matchingWarranty = cart.items.find(item => {
      //           return item.id == warrantyVariantID &&
      //             item.properties &&
      //             item.properties['Extended Warranty'] == parentProductHandle;
      //         });

      //         btn.dataset.inCart = matchingWarranty ? "true" : "false";

      //         btn.addEventListener('click', (e) => {
      //           e.preventDefault();

      //           // Prevent multiple clicks in short time (double add)
      //           if (btn.classList.contains('is-processing')) return;
      //           btn.classList.add('is-processing');

      //           if (btn.dataset.inCart === "true") {
      //             // --- Remove ONLY this warranty ---
      //             if (matchingWarranty) {
      //               console.log("is-process!!!!");
      //               let formData = { updates: { [matchingWarranty.key]: 0 } };
      //               fetch('/cart/update.js', {
      //                 method: "POST",
      //                 body: JSON.stringify(formData),
      //                 headers: { 'Content-Type': 'application/json' }
      //               })
      //                 .then(res => res.json())
      //                 .then(response => {
      //                   btn.dataset.inCart = "false";
      //                   btn.closest(".cart__item_wrp").querySelector(".cart__item")
      //                     .classList.remove("has-extended-product");
      //                   document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
                        
      //                 })
      //                 .catch(console.error)
      //                 .finally(() => btn.classList.remove('is-processing'));
      //             }
      //           } else {
      //             // --- Add warranty for THIS parent product ---
      //             let formData = {
      //               items: [{
      //                 id: warrantyVariantID,
      //                 quantity: parentQuantity, // Always same as main product
      //                 properties: {
      //                   'Extended Warranty': parentProductHandle,
      //                   '_related_product': warrantyVariantID + "_" + parentTitle
      //                 }
      //               }]
      //             };

      //              console.log("formData", formData);

      //             fetch('/cart/add.js', {
      //               method: "POST",
      //               body: JSON.stringify(formData),
      //               headers: { 'Content-Type': 'application/json' }
      //             })
      //               .then(res => res.json())
      //               .then(response => {
      //                  console.log("product added successfully..");
                      
      //                 btn.dataset.inCart = "true";
      //                 btn.closest(".cart__item_wrp").querySelector(".cart__item")
      //                   .classList.add("has-extended-product");
      //                 document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: response } }));
      //                 setTimeout(()=>{
      //                   updateCompareTotal();
                        
      //                 },1000);
                       
      //               })
      //               .catch(console.error)
      //               .finally(() => btn.classList.remove('is-processing'));
      //           }
      //         });
      //       });
      //     })
      //     .catch(console.error);
      // },
      updateCount: function (count) {
        var countEls = document.querySelectorAll(".cart-linkbubble-count");

        if (countEls.length) {
          countEls.forEach((el) => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach((b) => {
              b.classList.add("cart-link__bubble--visible");
            });
          } else {
            bubbles.forEach((b) => {
              b.classList.remove("cart-link__bubble--visible");
            });
          }
        }
      },
    });

    return CartForm;
  })();

  theme.headerSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;

    var selectors = {
      form: ".header-search__form",
      input: 'input[type="search"]',

      searchInlineContainer: ".site-header__search-container",
      searchInlineBtn: ".js-search-header",

      searchButton: "[data-predictive-search-button]",
      closeSearch: ".site-header__search-btn--cancel",

      wrapper: "#search-results",
      predictiveWrapper: "#search-predictive",
      resultDiv: "#predictive-search-results",
    };

    var cache = {};
    var activeForm;

    var classes = {
      isActive: "predicitive-active",
    };

    var config = {
      namespace: ".search",
      predictiveSearch: false,
      imageSize: "square",
    };

    var keys = {
      esc: 27,
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      initInlineSearch();

      cache.wrapper = document.querySelector(selectors.wrapper);
      if (!cache.wrapper) {
        return;
      }

      if (theme.settings.predictiveSearch) {
        // Only some languages support predictive search
        if (document.getElementById("shopify-features")) {
          var supportedShopifyFeatures = JSON.parse(
            document.getElementById("shopify-features").innerHTML
          );
          if (supportedShopifyFeatures.predictiveSearch) {
            config.predictiveSearch = true;
          }
        }
      }

      if (config.predictiveSearch) {
        cache.predictiveWrapper = document.querySelector(
          selectors.predictiveWrapper
        );
        config.imageSize = cache.predictiveWrapper.dataset.imageSize;
        cache.results = document.querySelector(selectors.resultDiv);
        cache.submit = cache.predictiveWrapper.querySelector(
          selectors.searchButton
        );
        cache.submit.on("click" + config.namespace, triggerSearch);
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        initForm(form);
      });
    }

    function initForm(form) {
      form.setAttribute("autocomplete", "off");
      form.on("submit" + config.namespace, submitSearch);

      var input = form.querySelector(selectors.input);
      input.on("focus" + config.namespace, handleFocus);
      if (config.predictiveSearch) {
        input.on("keyup" + config.namespace, handleKeyup);
      }
    }

    function reset() {
      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        cache.results.innerHTML = "";
        clearTimeout(searchTimeout);
      }
    }

    function close(evt) {
      // If close button is clicked, close as expected.
      // Otherwise, ignore clicks in search results, search form, or container elements
      if (evt && evt.target.closest) {
        if (evt.target.closest(selectors.closeSearch)) {
        } else {
          if (evt.target.closest(".header-search__form")) {
            return;
          } else if (evt.target.closest(".site-header__element--sub")) {
            return;
          } else if (evt.target.closest("#SearchResultsWrapper")) {
            return;
          } else if (evt.target.closest(".site-header__search-container")) {
            return;
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      cache.wrapper.classList.add("hide");

      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        clearTimeout(searchTimeout);
      }

      if (cache.inlineSearchContainer) {
        cache.inlineSearchContainer.classList.remove("is-active");
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        form.classList.remove("is-active");
      });

      window.off("click" + config.namespace);
    }

    function initInlineSearch() {
      cache.inlineSearchContainer = document.querySelector(
        selectors.searchInlineContainer
      );
      document.querySelectorAll(selectors.searchInlineBtn).forEach((btn) => {
        btn.addEventListener("click", openInlineSearch);
      });
    }

    function openInlineSearch(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchInlineContainer);
      container.classList.add("is-active");
      container.querySelector(".site-header__search-input").focus();

      enableCloseListeners();
    }

    function triggerSearch() {
      if (activeForm) {
        activeForm.submit();
      }
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += "*";
      }

      var params = paramUrl(obj);

      window.location.href = "/search?" + params;
      return false;
    }

    function handleKeyup(evt) {
      activeForm = evt.currentTarget.closest("form");

      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      if (evt.keyCode === keys.esc) {
        close();
        return;
      }

      search(evt.currentTarget);
    }

    function handleFocus(evt) {
      evt.currentTarget.parentNode.classList.add("is-active");
      enableCloseListeners();
    }

    function enableCloseListeners() {
      // Clicking out of search area closes it. Timeout to prevent immediate bubbling
      setTimeout(function () {
        window.on("click" + config.namespace, function (evt) {
          close(evt);
        });
      }, 0);

      // Esc key also closes search
      window.on("keyup", function (evt) {
        if (evt.keyCode === 27) {
          close();
        }
      });
    }

    function search(input) {
      var keyword = input.value;

      if (keyword === "") {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        q: q,
        "resources[type]": theme.settings.predictiveSearchType,
        "resources[limit]": 4,
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]":
          "title,product_type,variants.title,vendor",
      };

      var params = paramUrl(searchObj);

      fetch("/search/suggest.json?" + params)
        .then((response) => response.json())
        .then((suggestions) => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          cache.predictiveWrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              case "collections":
                data[type] = buildCollections(results);
                break;
              case "pages":
                data[type] = buildPages(results);
                break;
              case "articles":
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = "";
          cache.results.innerHTML = output;

          cache.wrapper.classList.remove("hide");
        });
    }

    function buildProducts(results) {
      var output = "";
      var products = [];

      results.forEach((product) => {
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio,
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(products, config.imageSize);

        output = `
			  <div data-type-products>
				<div class="new-grid product-grid" data-view="small">
				  ${markup}
				</div>
			  </div>
			`;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = "";

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
			  <div data-type-collections>
				<p class="h6 predictive__label">${theme.strings.searchCollections}</p>
				<ul class="no-bullets">
				  ${markup}
				</ul>
			  </div>
			`;
      }

      return output;
    }

    function buildPages(pages) {
      var output = "";

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
			  <div data-type-pages>
				<p class="h6 predictive__label">${theme.strings.searchPages}</p>
				<ul class="no-bullets">
				  ${markup}
				</ul>
			  </div>
			`;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = "";

      articles.forEach((article) => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(
            article.image,
            "200x200_crop_center"
          );
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
			  <div data-type-articles>
				<p class="h6 predictive__label">${theme.strings.searchArticles}</p>
				<div class="grid grid--uniform grid--no-gutters">
				  ${markup}
				</div>
			  </div>
			`;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = "";

      if (data.products && data.products !== "") {
        output += data.products;
      }

      if (data.collections && data.collections !== "") {
        output += data.collections;
      }

      if (data.pages && data.pages !== "") {
        output += data.pages;
      }

      if (data.articles && data.articles !== "") {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }

    return {
      init: init,
    };
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: ".collapsible-trigger",
      module: ".collapsible-content",
      moduleInner: ".collapsible-content__inner",
      tabs: ".collapsible-trigger--tab",
    };

    var classes = {
      hide: "hide",
      open: "is-open",
      autoHeight: "collapsible--auto-height",
      tabs: "collapsible-trigger--tab",
    };

    var namespace = ".collapsible";

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute("aria-expanded", state);

        trigger.off("click" + namespace);
        trigger.on("click" + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute("aria-controls");
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll(
          '[data-id="' + moduleId + '"]'
        );
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector(
            '[data-id="' + moduleId + '"]'
          );
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document
          .querySelectorAll(
            selectors.tabs + '[data-id="' + el.dataset.id + '"]'
          )
          .forEach((el) => {
            el.classList.remove(classes.open);
            newModule = document.querySelector(
              "#" + el.getAttribute("aria-controls")
            );
            setTransitionHeight(newModule, 0, true);
          });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute("aria-expanded", !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector(".spr-summary-actions-newreview");
        if (!btn) {
          return;
        }
        btn.off("click" + namespace);
        btn.on("click" + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + "px";
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css("height", "auto");
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: "[data-disclosure-form]",
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute("aria-expanded", false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute(
          "aria-expanded",
          !ariaExpanded
        );
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          "click",
          this.eventHandlers.onBodyClick
        );
      },
    });

    return Disclosure;
  })();

  theme.Drawer = (function () {
    function Drawer(id, position, options) {
      var defaults = {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + position,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + position,
        transition: "is-transitioning",
      };

      this.id = id;
      this.drawer = document.getElementById(id);

      if (!this.drawer) {
        return false;
      }

      this.drawerIsOpen = false;

      this.config = Object.assign(defaults, options);
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.drawer;

      this.init();
    }

    Drawer.prototype = Object.assign({}, Drawer.prototype, {
      init: function () {
        var _self = this;
        var pageElement = document.querySelector(".site-content");

        document.querySelectorAll(this.config.open).forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
          btn.addEventListener("click", this.open.bind(this));
        });

        document.querySelectorAll(this.config.close).forEach((btn) => {
          btn.addEventListener("click", this.close.bind(this));
        });

        pageElement.addEventListener("click", function (event) {
          if (!event.target.contains(this.drawer)) {
            _self.close();
          }
        });
      },

      open: function (evt) {
        var externalCall = false;

        if (this.drawerIsOpen) {
          return;
        }

        if (evt) {
          evt.preventDefault();
        } else {
          externalCall = true;
        }

        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          this.activeSource = evt.currentTarget;
          evt.currentTarget.setAttribute("aria-expanded", "true");
        }

        if (this.drawerIsOpen && !externalCall) {
          this.close();
        }

        this.drawer.classList.add(this.config.openClass);
        this.drawer.classList.add(this.config.transition);

        document.documentElement.classList.add(this.config.openClass);
        document.documentElement.classList.add(this.config.dirOpenClass);

        window.setTimeout(
          function () {
            this.drawer.classList.remove(this.config.transition);
          }.bind(this),
          500
        );

        this.drawerIsOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          elementToFocus: this.focusOnOpen,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerOpen"));
        document.dispatchEvent(new CustomEvent("drawerOpen." + this.id));
      },

      close: function () {
        if (!this.drawerIsOpen) {
          return;
        }
        // if (this.drawerIsOpen) return;
        document.activeElement.blur();

        this.drawer.classList.remove(this.config.openClass);
        this.drawer.classList.add(this.config.transition);

        document.documentElement.classList.remove(this.config.openClass),
        document.documentElement.classList.remove(this.config.dirOpenClass);

        window.setTimeout(
          function () {
            this.drawer.classList.remove(this.config.transition);

            if (
              this.activeSource &&
              this.activeSource.getAttribute("aria-expanded")
            ) {
              this.activeSource.setAttribute("aria-expanded", "false");
            }
          }.bind(this),
          500
        );

        this.drawerIsOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerClose." + this.id));
      },
    });

    return Drawer;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + name,
        openClass: "modal--is-active",
        closingClass: "modal--is-closing",
        bodyOpenClass: ["modal-open"],
        bodyOpenSolidClass: "modal-open--solid",
        bodyClosingClass: "modal-closing",
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector(".modal__inner");

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener("click", this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        "drawerOpen",
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          "aria-expanded",
          "true"
        );
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (evt.target.closest(".modal-content__inner")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          );
          this.modal.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false").focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        );
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        "keyup.modal",
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on("click.modal", this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");

      if (this.config.closeOffContentClick) {
        this.modal.off(".modal");
      }
    };

    return Modal;
  })();

  // Initialize in theme.js with theme.pageTransitions();
  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove("unloading");
      document.querySelectorAll(".btn-cart__checkout").forEach((el) => {
        el.classList.remove("btn--loading");
      });
    }
  };

  theme.pageTransitions = function () {
    if (document.body.dataset.transitions === "true") {
      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        document.querySelectorAll("a").forEach((a) => {
          window.setTimeout(function () {
            document.body.classList.remove("unloading");
          }, 1200);
        });
      }

      // Add disable transition class to various link types
      document
        .querySelectorAll(
          'a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
        )
        .forEach((el) => {
          el.classList.add("js-no-transition");
        });

      document.querySelectorAll("a:not(.js-no-transition)").forEach((el) => {
        el.addEventListener("click", function (evt) {
          if (evt.metaKey) return true;
          evt.preventDefault();
          document.body.classList.add("unloading");
          var src = el.getAttribute("href");
          window.setTimeout(function () {
            location.href = src;
          }, 50);
        });
      });

      document.querySelectorAll("a.mobile-nav__link").forEach((el) => {
        el.addEventListener("click", function () {
          theme.NavDrawer.close();
        });
      });
    }
  };

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: ".price-range",
      priceRangeSlider: ".price-range__slider",
      priceRangeInputMin: ".price-range__input-min",
      priceRangeInputMax: ".price-range__input-max",
      priceRangeDisplayMin: ".price-range__display-min",
      priceRangeDisplayMax: ".price-range__display-max",
    };

    function PriceRange(
      container,
      { onChange, onUpdate, ...sliderOptions } = {}
    ) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains("price-range")) {
          throw new Error(
            "You must instantiate PriceRange with a valid container"
          );
        }

        this.formEl = this.container.closest("form");
        this.sliderEl = this.container.querySelector(
          selectors.priceRangeSlider
        );
        this.inputMinEl = this.container.querySelector(
          selectors.priceRangeInputMin
        );
        this.inputMaxEl = this.container.querySelector(
          selectors.priceRangeInputMax
        );
        this.displayMinEl = this.container.querySelector(
          selectors.priceRangeDisplayMin
        );
        this.displayMaxEl = this.container.querySelector(
          selectors.priceRangeDisplayMax
        );

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue =
          parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (
          this.sliderEl &&
          this.sliderEl.noUiSlider &&
          typeof this.sliderEl.noUiSlider.destroy === "function"
        ) {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on("update", (values) => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on("change", (values) => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-to-cart";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        console.log("Add to cart btn clicked.....");

        if (status.loading) {
          return;
        }
        console.log("After Loading.....");

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");

        status.loading = true;

        var data = theme.utils.serialize(this.form);

        // custom code
          console.log("data",data);
          const countryCode = document.documentElement.getAttribute('country');
          if (countryCode !== 'US') {
            if(data.includes("product-id=6078153326755")){
              console.log("product is 2500mAh 18650 Battery");
              this.addToCart.classList.remove("btn--loading");
              status.loading = false;

              customNonUsRestricted();
              return;
            }
          }
        // custom code

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
              
                // new theme.Drawer("header_minicart", "right").open();
              }

              status.loading = false;
              this.addToCart.classList.remove("btn--loading");
              // console.log("Added Product",product);

              fetch(`/variants/${product.id}.js`)
              .then(res => res.json())
              .then(variantData => {
                // Merge relevant variant info into the product object
                product.price = variantData.price;
                product.compare_at_price = variantData.compare_at_price;

                addToCartPopup_fn(product);
              })
              .catch(err => {
                console.error("Error fetching variant details:", err);
                addToCartPopup_fn(product); // fallback
              });

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  theme.ProductUpsellForm = (function () {
    var status = {
      loading: false,
    };

    function UpsellForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-upsell-product";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    UpsellForm.prototype = Object.assign({}, UpsellForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");
        this.addToCart.querySelector("[data-upsell-text]").innerText =
          theme.strings.upgrading;
        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
                // new theme.Drawer("header_minicart", "right").open();
              }

              status.loading = false;
              this.addToCart.classList.remove("btn--loading");
              this.addToCart.querySelector("[data-upsell-text]").innerText =
                theme.strings.upgraded;
              this.addToCart.disabled = true;

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return UpsellForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: "[data-product-single-media-group]",
      xrButton: "[data-shopify-xr]",
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector("model-viewer");
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: setupShopifyXr,
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load("modelViewerUiStyles");
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector("#ModelJson-" + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener("mediaVisible", function () {
        xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener("mediaHidden", function () {
        xrButton.element.setAttribute(
          "data-shopify-model3d-id",
          xrButton.defaultId
        );
        model.modelViewerUi.pause();
      });

      model.container.addEventListener("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute("min") || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this)
        );

        this.minus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this)
        );

        this.input.addEventListener(
          "change",
          function (evt) {
            this._change(this._getQty());
          }.bind(this)
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  theme.DeleteProduct = (function () {
    function DeleteProduct(el, options) {
      this.wrapper = el;

      var defaults = {
        namespace: null,
        isCart: false,
      };

      this.options = Object.assign({}, defaults, options);
      this.init();
    }

    DeleteProduct.prototype = Object.assign({}, DeleteProduct.prototype, {
      init: function () {
        this.wrapper.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.wrapper.classList.add('btn--loading');
            this._delete();
          }.bind(this)
        );
      },

      _delete: function () {
        document.dispatchEvent(
          new CustomEvent("cart:delete" + this.options.namespace, {
            detail: [this.options.key, 0, this.wrapper],
          })
        );
      },
    });

    return DeleteProduct;
  })();

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: "animate-out",
      isPaused: "is-paused",
      isActive: "is-active",
    };

    var selectors = {
      allSlides: ".slideshow__slide",
      currentSlide: ".is-selected",
      wrapper: ".slideshow-wrapper",
      pauseButton: ".slideshow__pause",
    };

    var productSelectors = {
      thumb: ".product__thumb-item:not(.hide)",
      links: ".product__thumb-item:not(.hide) a",
      arrow: ".product__thumb-arrow",
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false,
      childNav: null,
      childNavScroller: null,
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
      imagesLoaded: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        );
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        );
        this.arrows = this.args.childNav.querySelectorAll(
          productSelectors.arrow
        );
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper?.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        "resize",
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            "transitionend",
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
          }
        }

        // Enable/Disable arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle("disable", index === 0);
          this.arrows[1].classList.toggle("disable",index === this.childNavLinks.length - 1);
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add("is-active");

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute("data-index", i);

          link.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "focus",
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "keydown",
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener("click", this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains("product__thumb-arrow--prev")
        ) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: ".js-drawer-open-availability",
      modalOpenBtn: ".js-modal-open-availability",
      productTitle: "[data-availability-product-title]",
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign(
      {},
      StoreAvailability.prototype,
      {
        updateContent: function (variantId) {
          var variantSectionUrl =
            this.baseUrl +
            "/variants/" +
            variantId +
            "/?section_id=store-availability";

          var self = this;

          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (html.trim() === "") {
                this.container.innerHTML = "";
                return;
              }

              self.container.innerHTML = html;
              self.container.innerHTML =
                self.container.firstElementChild.innerHTML;

              // Setup drawer if have open button
              if (self.container.querySelector(selectors.drawerOpenBtn)) {
                self.drawer = new theme.Drawers(
                  "StoreAvailabilityDrawer",
                  "availability"
                );
              }

              // Setup modal if have open button
              if (self.container.querySelector(selectors.modalOpenBtn)) {
                self.modal = new theme.Modals(
                  "StoreAvailabilityModal",
                  "availability"
                );
              }

              var title = self.container.querySelector(selectors.productTitle);
              if (title) {
                title.textContent = self.productTitle;
              }
            });
        },
      }
    );

    return StoreAvailability;
  })();

  /*============================================================================
  VariantAvailability
  - Cross out sold out or unavailable variants
  - To disable, set dynamicVariantsEnable to false in theme.liquid
  - Required markup:
    - class=variant-input-wrap to wrap select or button group
    - class=variant-input to wrap button/label
    ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: "disabled",
    };

    function VariantAvailability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    VariantAvailability.prototype = Object.assign(
      {},
      VariantAvailability.prototype,
      {
        init: function () {
          this.container.on(
            "variantChange" + this.namespace,
            this.setAvailability.bind(this)
          );

          // Set default state based on current selected variant
          this.setAvailability(null, this.currentVariantObject);
        },

        setAvailability: function (evt, variant) {
          if (evt) {
            var variant = evt.detail.variant;
          }

          // Object to hold all options by value.
          // This will be what sets a button/dropdown as
          // sold out or unavailable (not a combo set as purchasable)
          var valuesToManage = {
            option1: [],
            option2: [],
            option3: [],
          };

          var ignoreIndex = null;
          var availableVariants = this.variantsObject.filter(function (el) {
            if (!variant || variant.id === el.id) {
              return false;
            }

            if (
              variant.option2 === el.option2 &&
              variant.option3 === el.option3
            ) {
              return true;
            }

            if (
              variant.option1 === el.option1 &&
              variant.option3 === el.option3
            ) {
              return true;
            }

            if (
              variant.option1 === el.option1 &&
              variant.option2 === el.option2
            ) {
              return true;
            }
          });

          var variantObject = {
            variant: variant,
          };

          var variants = Object.assign({}, { variant }, availableVariants);

          // Disable all options to start.
          // If coming from a variant change event, do not disable
          // options inside current index group
          this.container
            .querySelectorAll(".variant-input-wrap")
            .forEach((group) => {
              this.disableVariantGroup(group);
            });

          // Loop through each available variant to gather variant values
          for (var property in variants) {
            if (variants.hasOwnProperty(property)) {
              var item = variants[property];
              if (!item) {
                return;
              }

              var value1 = item.option1;
              var value2 = item.option2;
              var value3 = item.option3;
              var soldOut = item.available === false;

              if (value1 && ignoreIndex !== "option1") {
                valuesToManage.option1.push({
                  value: value1,
                  soldOut: soldOut,
                });
              }
              if (value2 && ignoreIndex !== "option2") {
                valuesToManage.option2.push({
                  value: value2,
                  soldOut: soldOut,
                });
              }
              if (value3 && ignoreIndex !== "option3") {
                valuesToManage.option3.push({
                  value: value3,
                  soldOut: soldOut,
                });
              }
            }
          }

          // Loop through all option levels and send each
          // value w/ args to function that determines to show/hide/enable/disable
          for (var [option, values] of Object.entries(valuesToManage)) {
            this.manageOptionState(option, values);
          }
        },

        manageOptionState: function (option, values) {
          var group = this.container.querySelector(
            '.variant-input-wrap[data-index="' + option + '"]'
          );

          // Loop through each option value
          values.forEach((obj) => {
            this.enableVariantOption(group, obj);
          });
        },

        enableVariantOptionByValue: function (array, index) {
          var group = this.container.querySelector(
            '.variant-input-wrap[data-index="' + index + '"]'
          );

          for (var i = 0; i < array.length; i++) {
            this.enableVariantOption(group, array[i]);
          }
        },

        enableVariantOption: function (group, obj) {
          // Selecting by value so escape it
          var value = obj.value.replace(
            /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
            "\\$1"
          );

          if (this.type === "dropdown") {
            group.querySelector(
              'option[value="' + value + '"]'
            ).disabled = false;
          } else {
            var buttonGroup = group.querySelector(
              '.variant-input[data-value="' + value + '"]'
            );
            var input = buttonGroup.querySelector("input");
            var label = buttonGroup.querySelector("label");

            // Variant exists - enable & show variant
            input.classList.remove(classes.disabled);
            label.classList.remove(classes.disabled);

            // Variant sold out - cross out option (remains selectable)
            if (obj.soldOut) {
              input.classList.add(classes.disabled);
              label.classList.add(classes.disabled);
            }
          }
        },

        disableVariantGroup: function (group) {
          if (this.type === "dropdown") {
            group.querySelectorAll("option").forEach((option) => {
              option.disabled = true;
            });
          } else {
            group.querySelectorAll("input").forEach((input) => {
              input.classList.add(classes.disabled);
            });
            group.querySelectorAll("label").forEach((label) => {
              label.classList.add(classes.disabled);
            });
          }
        },
      }
    );

    return VariantAvailability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;

    var videoHolderId = "video-wrapper";
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: ".product-video-trigger--mp4",
      mp4Player: ".product-video-mp4-sound",
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load("youtubeSdk");
    }

    var modal = new theme.Modals("video-modal", "video-wrapper", {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "video-modal-open"],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerYouTubeModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener("click", triggerMp4Modal);
    });

    document.addEventListener("modalClose.video-modal", closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute("href"));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: "sound",
        events: {
          onReady: onYoutubeReady,
        },
      });
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove("hide");

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector("video").play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = "";
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  theme.Accordion = (function () {
    function Accordion(container) {
      this.container = container;
      this.init();
    }

    Accordion.prototype = Object.assign({}, Accordion.prototype, {
      init: function () {
        var self = this;
        this.container
          .querySelectorAll("[data-heading-selector]")
          .forEach((el) => {
            let type = el.dataset.value;
            el.addEventListener("click", function () {
              [...self.container.querySelectorAll(".item")].map((x) =>
                x.classList.remove("active")
              );
              [...self.container.querySelectorAll("[data-faq-card]")].map((x) =>
                x.classList.add("hide")
              );
              [...self.container.querySelectorAll("[data-faq-card-head]")].map(
                (x) => x.classList.add("hide")
              );
              [
                ...self.container.querySelectorAll(
                  '[data-type="' + type + '"]'
                ),
              ].map((x) => x.classList.remove("hide"));

              this.classList.add("active");
            });
          });

        this.container
          .querySelectorAll("[data-faq-card]")
          .forEach((element) => {
            if (!element.querySelector("[data-question]")) return;
            element
              .querySelector("[data-question]")
              .addEventListener("click", function () {
                element.closest("[data-faq-card]").classList.toggle("active");
                if (
                  element
                    .closest("[data-faq-card]")
                    .classList.contains("active")
                ) {
                  element
                    .querySelector('[type="button"]')
                    .setAttribute("aria-expanded", "true");
                  element
                    .querySelector("[data-answer]")
                    .setAttribute("aria-hidden", "false");
                } else {
                  element
                    .querySelector('[type="button"]')
                    .setAttribute("aria-expanded", "false");
                  element
                    .querySelector("[data-answer]")
                    .setAttribute("aria-hidden", "true");
                }
              });
          });

        this.container
          .querySelectorAll("[data-faq-card-head]")
          .forEach((element) => {
            let type = element.dataset.type;
            element.addEventListener("click", () => {
              // console.log(
              //   ...self.container.querySelectorAll("[data-faq-card-head]")
              // );
              this.container
                .querySelectorAll('[data-type="' + type + '"]')
                .forEach((el) => {
                  el.classList.toggle("visible");
                });
            });
          });
      },
    });

    return Accordion;
  })();

  theme.Header = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
      searchButtonToggle: "[data-search-toggle]",
    };

    function Header(container) {
      this.container = container;
      this.init();
    }

    Header.prototype = Object.assign({}, Header.prototype, {
      init: function () {
        this.__search();
        this.__mobileNav();
        this.__miniCart();
        theme.headerSearch.init();

        var localeElement = this.container.querySelector(selectors.locale);
        var currencyElement = this.container.querySelector(selectors.currency);
        
        if (localeElement) {
          this.localeDisclosure = new theme.Disclosure(localeElement);
        }        
        if (currencyElement) {
          this.currencyDisclosure = new theme.Disclosure(currencyElement);
        }

        // Enable header cart drawer when not on cart page
        if (!document.body.classList.contains("template-cart")) {
          new theme.HeaderCart();
        }
      },

      __search: function () {
        var search = document.querySelector(selectors.searchButtonToggle);
        // search.addEventListener('click', (e) => {
        // 	e.preventDefault();
        // });
      },

      // __mobileNav() {
      //   new theme.Drawer("header-mobile__menu", "left");

      //   document
      //     .querySelectorAll("[data-dropdown-toggle]")
      //     .forEach((element) => {

      //       element.addEventListener("click", (e) => {
      //         e.preventDefault();
      //         element.closest(".site--nav-dropdown").classList.toggle("active");
      //       });
      //     });
      // },
      __mobileNav() {
        new theme.Drawer("header-mobile__menu", "left");

        document
          .querySelectorAll("[data-dropdown-toggle]")
          .forEach((element) => {
            element.addEventListener("click", (e) => {
              e.preventDefault();

              const dropdownWrapper = element.closest(".site--nav-dropdown");
              const parentNav = element.closest(".site-navigation.mobile.main-navigation");

              // Proceed only if inside correct nav
              if (dropdownWrapper && parentNav) {
                // Remove active from all other dropdowns inside same nav
                parentNav.querySelectorAll(".site--nav-dropdown.active").forEach((activeEl) => {
                  if (activeEl !== dropdownWrapper) {
                    activeEl.classList.remove("active");
                  }
                });

                // Toggle only the clicked one
                dropdownWrapper.classList.toggle("active");
              }
            });
          });
      },

      __miniCart() {
        if (!document.body.classList.contains("template-cart")) {
          new theme.Drawer("header_minicart", "right");
        }
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return Header;
  })();

  theme.ProductSlider = (function () {
    function ProductSlider(container) {
      this.container = container;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#ProductSlider_" + sectionId);

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ProductSlider.prototype = Object.assign({}, ProductSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          cellAlign: "left",
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30, }, 
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);


        // If container not set, section has been reinitialized.
        // Update this.container to refreshed DOM element
        if (!container) {
          this.container = document.getElementById(this.containerId);
        }

        this.quickAdd = new theme.QuickAdd(this.container);
        this.quickShop = new theme.QuickShop(this.container);
        updateDotPagination(this.container);
      },
    });

    return ProductSlider;
  })();

  theme.Footer = (function () {
    var selectors = {
      scroll: "[data-scrollup]",
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function Footer(container) {
      this.container = container;

      this.init();
    }

    Footer.prototype = Object.assign({}, Footer.prototype, {
      init: function () {
        var localeElement = this.container.querySelector(selectors.locale);
        var currencyElement = this.container.querySelector(selectors.currency);

        if (localeElement) {
          this.localeDisclosure = new theme.Disclosure(localeElement);
        }

        if (currencyElement) {
          this.currencyDisclosure = new theme.Disclosure(currencyElement);
        }

        this.__footerToggle();
        this.__scrollUp();
      },
      __footerToggle: function () {
        this.container
          .querySelectorAll("[data-footer-block]")
          .forEach((element) => {
            let toggleBtn = element.querySelector(".title");
           if(toggleBtn) {
                  toggleBtn.addEventListener("click", function () {
                    element.classList.toggle("active");
                  });
           }
          });
      },
      __scrollUp() {
        let scrollElement = document.querySelector(selectors.scroll);
        if (scrollElement) {
          document.addEventListener("scroll", () => {
            var scrollValue = window.scrollY;
            if (scrollValue > 1000) {
              scrollElement.classList.add("active");
            } else {
              scrollElement.classList.remove("active");
            }
          });

          scrollElement.addEventListener("click", () => {
            document.documentElement.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          });
        }
      },
      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return Footer;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: "on-sale",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      interactable: "video-interactable",
      visuallyHide: "visually-invisible",
    };

    var selectors = {
      productVideo: ".product__video",
      videoParent: ".product__video-wrapper",
      slide: ".product-main-slide",
      currentSlide: ".is-selected",
      startingSlide: ".starting-slide",
      variantType: ".variant-wrapper",
      blocks: "[data-product-blocks]",
      blocksHolder: "[data-blocks-holder]",
    };

    function Product(container) {
      this.container = container;
      var sectionId = (this.sectionId =
        container.getAttribute("data-section-id"));
      var productId = (this.productId =
        container.getAttribute("data-product-id"));

      this.inModal = container.dataset.modal === "true";
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history === "true" || false,
        namespace: ".product-" + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "680x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickShopModal-" + productId);
      }

      this.selectors = {
        variantsJson: "[data-variant-json]",
        currentVariantJson: "[data-current-variant-json]",
        form: ".product-single__form",

        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: "[data-product-thumb]",
        thumbSlider: "[data-product-thumbs]",
        thumbScroller: ".product-thumbs__scroller",
        mainSlider: "[data-product-photos]",
        imageContainer: "[data-product-images]",
        productImageMain: "[data-product-image-main]",
        priceWrapper: "[data-product-price-wrap]",
        price: "[data-product-price]",
        comparePrice: "[data-compare-price]",
        savePrice: "[data-save-price]",
        priceA11y: "[data-a11y-price]",
        comparePriceA11y: "[data-compare-price-a11y]",
        unitWrapper: "[data-unit-price-wrapper]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-base]",
        sku: "[data-sku]",
        inventory: "[data-product-inventory]",
        incomingInventory: "[data-incoming-inventory]",
        colorLabel: "[data-variant-color-label]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        originalSelectorId: "[data-product-select]",
        singleOptionSelector: "[data-variant-input]",
        variantColorSwatch: ".variant__input--color-swatch",
        availabilityContainer: "[data-store-availability-holder]",
      };

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider.querySelector("img");

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener(
            "modalOpen.QuickShopModal-" + this.productId,
            this.openModalProduct.bind(this)
          );
          document.addEventListener(
            "modalClose.QuickShopModal-" + this.productId,
            this.closeModalProduct.bind(this)
          );
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.variantDropdownUpdated();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.initProductProperties();
        }

        this.reviewScroll();

        // Quick add hook
        window.off("quickadd:loaded:" + this.sectionId);
        window.on(
          "quickadd:loaded:" + this.sectionId,
          this.initQuickAddForm.bind(this)
        );
      },

      variantDropdownUpdated: function () {
        document
          .querySelectorAll(".select-variant__dropdown")
          .forEach((element) => {
            element.addEventListener("click", function (e) {
              let elementToggle = element.querySelector(".select-selected");
              if (e.target.contains(elementToggle)) {
                this.classList.toggle("active");
              }
            });

            element.querySelectorAll(".item").forEach((e) => {
              e.addEventListener("click", function () {
                let variantName = e.innerText;
                [...element.querySelectorAll(".item")].map((x) =>
                  x.classList.remove("selected")
                );
                element.querySelector(".variant-selected__main").innerText =
                  variantName;
                element
                  .closest(".variant-wrapper")
                  .querySelectorAll(".variant-input")
                  .forEach((elm) => {
                    if (elm.dataset.value === variantName) {
                      elm.querySelector("input").click();
                    }
                  });
                e.classList.add("selected");
                element.classList.remove("active");
              });
            });
          });

        document.addEventListener("click", function (event) {
          var dropdowns = document.querySelectorAll(
            ".select-variant__dropdown"
          );
          dropdowns.forEach(function (dropdown) {
            if (
              !dropdown.contains(event.target) &&
              !event.target.closest(".select-variant__dropdown")
            ) {
              dropdown.classList.remove("active");
            }
          });
        });
      },

      reviewScroll: function () {
        let reviewStar = document.querySelector(".review-stars");
        if (!reviewStar) return;
        reviewStar.addEventListener("click", function (events) {
          events.preventDefault();
          document.querySelector(".shopify-app-block").scrollIntoView();
        });
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(
            this.selectors.thumbScroller
          ),
          productImageMain: this.container.querySelector(
            this.selectors.productImageMain
          ),

          // Price-related
          priceWrapper: this.container.querySelector(
            this.selectors.priceWrapper
          ),
          comparePriceA11y: this.container.querySelector(
            this.selectors.comparePriceA11y
          ),
          comparePrice: this.container.querySelector(
            this.selectors.comparePrice
          ),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
          atcPrice: this.container.querySelector('.custom-atc-price'),
          atcComparePrice: this.container.querySelector('.custom-atc-compare-price'),
          atcSavePrice: this.container.querySelector('.custom-atc-save-price'),
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initUpsellProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        );
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initResponsiveVideo();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var id = this.container.getAttribute("data-product-id");

        if (!id) {
          return;
        }

        // Remove current product if already in recently viewed array
        var i = theme.recentlyViewedIds.indexOf(id);
        if (i > -1) {
          theme.recentlyViewedIds.splice(i, 1);
        }

        // Add id to array
        theme.recentlyViewedIds.unshift(id);

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(
            "recently-viewed",
            JSON.stringify(theme.recentlyViewedIds)
          );
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(
          this.selectors.variantsJson
        );

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
        };

        var swatches = this.container.querySelectorAll(
          this.selectors.variantColorSwatch
        );
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              "change",
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateAvailability.bind(this)
          );
        }

        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateCartButton.bind(this)
        );
        this.container.on(
          "variantImageChange" + this.settings.namespace,
          this.updateVariantImage.bind(this)
        );
        this.container.on(
          "variantPriceChange" + this.settings.namespace,
          this.updatePrice.bind(this)
        );
        this.container.on(
          "variantUnitPriceChange" + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        );

        if (this.container.querySelectorAll(this.selectors.sku).length) {
          this.container.on(
            "variantSKUChange" + this.settings.namespace,
            this.updateSku.bind(this)
          );
        }

        var inventoryEl = this.container.querySelector(
          this.selectors.inventory
        );
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateInventory.bind(this)
          );
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(
            this.selectors.currentVariantJson
          );

          if (currentVariantJson) {
            var variantType = this.container.querySelector(
              selectors.variantType
            );

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' +
            this.settings.imageSetName +
            '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on(
              "variantChange" + this.settings.namespace,
              this.updateImageSet.bind(this)
            );
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initProductProperties: function () {
        let element = this.container.querySelector("[data-product-properties]");
        if (!element) return;

        document
          .querySelectorAll(".select-properties__dropdown")
          .forEach((element) => {
            element.addEventListener("click", function () {
              this.classList.toggle("active");
            });

            element.querySelectorAll(".item").forEach((e) => {
              e.addEventListener("click", function () {
                let propertiesName = e.innerHTML;
                let productPropertiesValue = e.dataset.value;

                element.querySelector("input").value = productPropertiesValue;

                element.querySelector("[data-line-name]").innerHTML =
                  propertiesName;
                [...element.querySelectorAll(".item")].map((x) =>
                  x.classList.remove("selected")
                );
                e.classList.add("selected");
              });

              e.addEventListener("click", function () {
                if (element.querySelector("input").value != 0) {
                  element.querySelector(".select-selected").style.borderColor =
                    "#242424";
                }
              });
            });
          });

        document
          .querySelector("[data-add-to-cart]")
          .addEventListener("click", function (event) {
            document
              .querySelectorAll(".select-properties__dropdown")
              .forEach((element) => {
                element.querySelectorAll(".item").forEach((e) => {
                  if (element.querySelector("input").value == 0) {
                    event.preventDefault();
                    element.querySelector(
                      ".select-selected"
                    ).style.borderColor = "#ff0000";
                  }
                });
              });
          });
      },

      initQtySelector: function () {
        this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
          new theme.QtySelector(el, {
            namespace: ".product",
          });
        });
      },

      initAjaxProductForm: function () {
        new theme.AjaxProduct(this.cache.form, ".add-to-cart");
      },

      initUpsellProductForm: function () {
        document
          .querySelectorAll("[data-upsell-selector]")
          .forEach((element) => {
            let formElement = element.querySelector(".shopify-product-form");
            new theme.ProductUpsellForm(formElement, ".add-upsell-product");
          });
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(
          this.selectors.colorLabel + `[data-index="${index}"`
        ).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(
          this.selectors.addToCartText
        );

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      // updatePrice: function (evt) {
      //   var variant = evt.detail.variant;

      //   if (variant) {
      //     // If no price element, form initiated later than rest of
      //     // product page. Update cached elements
      //     if (!this.cache.price) {
      //       this.cacheElements();
      //     }
      //     // console.log(
      //     //   "variant.price",
      //     //   theme.Currency.formatMoney(
      //     //     variant.price,
      //     //     theme.settings.moneyFormat
      //     //   ).replace(/(\.00|,00)$/, "") // Removes .00 or ,00 from formatted currency
      //     // );

      //     // Regular price
      //     this.cache.price.innerHTML = theme.Currency.formatMoney(
      //       variant.price,
      //       theme.settings.moneyFormat
      //     ).replace(/(\.00|,00)$/, "");

      //     // Sale price, if necessary
      //     if (variant.compare_at_price > variant.price) {
      //       this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
      //         variant.compare_at_price,
      //         theme.settings.moneyFormat
      //       );
      //       this.cache.priceWrapper.classList.remove(classes.hidden);
      //       this.cache.price.classList.add(classes.onSale);
      //       if (this.cache.comparePriceA11y) {
      //         this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
      //       }
      //       if (this.cache.priceA11y) {
      //         this.cache.priceA11y.setAttribute("aria-hidden", "false");
      //       }

      //       var savings = variant.compare_at_price - variant.price;
      //       // if (theme.settings.saveType == "percent") {
      //       //   savings =
      //       //     Math.round((savings * 100) / variant.compare_at_price) + "%";
      //       // } else {
      //       //   savings = theme.Currency.formatMoney(
      //       //     savings,
      //       //     theme.settings.moneyFormat
      //       //   );
      //       // }
      //      savings = Math.round((savings * 100) / variant.compare_at_price) + "%";

      //       this.cache.savePrice.classList.remove(classes.hidden);
      //       this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
      //         "[saved_amount]",
      //         savings
      //       );
            
      //     } else {
      //       if (this.cache.priceWrapper) {
      //         this.cache.priceWrapper.classList.add(classes.hidden);
      //       }
      //       this.cache.savePrice.classList.add(classes.hidden);
      //       this.cache.price.classList.remove(classes.onSale);
      //       if (this.cache.comparePriceA11y) {
      //         this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
      //       }
      //       if (this.cache.priceA11y) {
      //         this.cache.priceA11y.setAttribute("aria-hidden", "true");
      //       }
      //     }
      //   }
      // },
      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // Re-cache if needed
          if (!this.cache.price) {
            this.cacheElements();
          }

          // =========================
          // MAIN PRICE (EXISTING)
          // =========================
          this.cache.price.innerHTML = theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          ).replace(/(\.00|,00)$/, "");

          // =========================
          // 🔥 ADD THIS (ATC PRICE)
          // =========================
          if (this.cache.atcPrice) {
            this.cache.atcPrice.innerHTML = theme.Currency.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            ).replace(/(\.00|,00)$/, "");
          }

          // =========================
          // SALE LOGIC
          // =========================
          if (variant.compare_at_price > variant.price) {

            // Main compare price
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            );

            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);

            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "false");
            }

            // Savings %
            var savings = variant.compare_at_price - variant.price;
            savings = Math.round((savings * 100) / variant.compare_at_price) + "%";

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
              "[saved_amount]",
              savings
            );

            // =========================
            // 🔥 ADD THIS (ATC SALE)
            // =========================
            if (this.cache.atcComparePrice) {
              this.cache.atcComparePrice.innerHTML = theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.settings.moneyFormat
              );
            }

            if (this.cache.atcSavePrice) {
              this.cache.atcSavePrice.innerHTML = "Save " + savings;
            }

          } else {

            // Main reset
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }

            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);

            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "true");
            }

            // =========================
            // 🔥 ADD THIS (ATC RESET)
            // =========================
            if (this.cache.atcComparePrice) {
              this.cache.atcComparePrice.innerHTML = "";
            }

            if (this.cache.atcSavePrice) {
              this.cache.atcSavePrice.innerHTML = "";
            }
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            );
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.hidden);
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
            ? this.variants.currentVariant
            : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ));
        var set = this.settings.imageSetName + "_" + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
            ? this.variants.currentVariant
            : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        );

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll(".product__thumb-item")
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
          });
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = "";
        var hideSku = true;

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
            hideSku = false;
          }

          if (this.container.querySelectorAll(this.selectors.sku).length > 0)
            this.container
              .querySelectorAll(this.selectors.sku)
              .forEach((el) => {
                el.classList.toggle(classes.hidden, hideSku);
                el.querySelector("[data-sku-id]").textContent = newSku;
              });
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === "continue"
        ) {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (
          variant.inventory_management === "shopify" &&
          window.inventories &&
          window.inventories[this.productId]
        ) {
          var variantInventoryObject =
            window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === "continue") {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, showInventory, quantity);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming === "true" &&
            quantity <= this.settings.inventoryThreshold
          ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          );
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest(".product-block");

        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add("inventory--low");
          el.textContent = theme.strings.stockLabel.replace("[count]", qty);
        } else {
          el.parentNode.classList.remove("inventory--low");
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest(".product-block");

        if (!el) {
          return;
        }

        var textEl = el.querySelector(".js-incoming-text");

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace("[date]", date)
            : theme.strings.willBeInStockAfter.replace("[date]", date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(
          selectors.productVideo
        );

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType;
          if (type === "youtube") {
            this.initYoutubeVideo(vid);
          } else if (type === "mp4") {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== "sound") {
          player.mute();
        }

        obj.parent.classList.remove("loading");
        obj.parent.classList.add("loaded");

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add("video-interactable");
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === "true") {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: "mp4",
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === "function") {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === "mp4") {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute("data-video-type");
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        var playPromise = player.play();

        player.focus();

        // When existing focus on the element, go back to thumbnail
        player.addEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player
                .closest(selectors.videoParent)
                .setAttribute("data-video-style", "unmuted");
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        player.removeEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );
        if (player && typeof player.pause === "function") {
          player.removeAttribute("controls");
          player.pause();
        }
      },

      // Return focus to
      returnFocusToThumbnail: function () {
        var thumb = this.container.querySelector(
          '.product__thumb-item[data-index="' +
          this.settings.currentSlideIndex +
          '"] a'
        );
        if (thumb) {
          thumb.focus();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        );
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      initResponsiveVideo: function () {
        var selector = document.querySelector("[data-product-description]");
        if (!selector) return false;
        selector
          .querySelectorAll('iframe[src*="youtube.com/embed"]')
          .forEach((element) => {
            let videoWrapper = document.createElement("div");
            videoWrapper.setAttribute("class", "video-wrapper");

            element.parentNode.insertBefore(videoWrapper, element);
            videoWrapper.appendChild(element);
          });
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        );

        var newImage = this.container.querySelector(
          '.product__thumb[data-id="' + variant.featured_media.id + '"]'
        );
        var imageIndex = this.getThumbIndex(newImage);

        // If there is no index, slider is not initalized
        if (typeof imageIndex === "undefined") {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (
          this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
        ) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add("is-selected");
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(
            selectors.startingSlide
          );
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === "beside",
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          setGallerySize: false,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        );
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
       updateDotPagination(this.cache.mainSlider);
      },

      onSlideChange: function (index) {
        updateDotPagination(this.cache.mainSlider);
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' +
          this.settings.currentSlideIndex +
          '"]'
        );

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName
          ? this.cache.mainSlider.querySelectorAll(
            ".flickity-slider .product-main-slide"
          )[index]
          : this.cache.mainSlider.querySelector(
            '.product-main-slide[data-index="' + index + '"]'
          );

        prevSlide.setAttribute("tabindex", "-1");
        nextSlide.setAttribute("tabindex", 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;      
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent("mediaHidden", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== "sound"
            ) {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent("mediaVisible", {
              bubbles: true,
              cancelable: true,
            })
          );
          slide
            .querySelector(".shopify-model-viewer-ui__button")
            .setAttribute("tabindex", 0);
          slide
            .querySelector(".product-single__close-media")
            .setAttribute("tabindex", 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute("data-index");
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(
            selectors.blocksHolder
          );
          var url = this.blocksHolder.dataset.url;

          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var blocks = doc.querySelector(selectors.blocks);

                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll("[id]").forEach((el) => {
                  // Update input `id`
                  var val = el.getAttribute("id");
                  el.setAttribute("id", val + "-modal");

                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute("for", val + "-modal");
                  }

                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(
                    `[aria-controls="${val}"]`
                  );
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute(
                      "aria-controls",
                      val + "-modal"
                    );
                  }
                });

                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                var formId = form.getAttribute("id");
                blocks.querySelectorAll("[form]").forEach((el) => {
                  el.setAttribute("form", formId);
                });

                this.blocksHolder.innerHTML = "";
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add("product-form-holder--loaded");

                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent("quickview:loaded", {
                    detail: {
                      productId: this.sectionId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                "quickview:loaded",
                function (evt) {
                  if (evt.detail.productId === this.sectionId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        document.dispatchEvent(
          new CustomEvent("quickview:open", {
            detail: {
              initialized: initialized,
              productId: this.sectionId,
            },
          })
        );
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container
          .querySelectorAll(".js-product-inventory-data")
          .forEach((el) => {
            var productId = el.dataset.productId;
            window.inventories[productId] = {};

            el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
              window.inventories[productId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                policy: el.dataset.policy,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              };
            });
          });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      initQuickAddForm: function () {
        this.updateModalProductInventory();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        );
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ":not(." +
              self.classes.hidden +
              ")"
            );
            currentMedia.dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            "click",
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              );
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        var modelViewers = this.container.querySelectorAll("model-viewer");
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },
    });

    return Product;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: ".js-photoswipe__zoom",
      images: ".photoswipe__image",
      slideshowTrack: ".flickity-viewport ",
      activeImage: ".is-selected",
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = ".photoswipe-" + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === "false") {
        return;
      }

      if (container.dataset.slider === "true") {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container
          .querySelectorAll(selectors.trigger)
          .forEach((trigger) => {
            trigger.on("click" + this.namespace, this.triggerClick.bind(this));
          });
      },

      triggerClick: function (evt) {
        this.items = this.getImageData();

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget;

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
            selectors.slideshowTrack + selectors.images
          )
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute("data-photoswipe-src"),
            w: el.getAttribute("data-photoswipe-width"),
            h: el.getAttribute("data-photoswipe-height"),
            el: el,
            initialZoomLevel: 0.5,
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll(".pswp")[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: "zoom",
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        this.gallery.listen("afterChange", this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(
          new CustomEvent("photoswipe:afterChange", {
            detail: {
              index: index,
            },
          })
        );
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add("pswp-open-in-ios");

        window.addEventListener("resize", this.syncHeight);

        this.gallery.listen("destroy", () => {
          document.documentElement.classList.remove("pswp-open-in-ios");
          window.scrollTo(0, initialScrollPos);
        });
      },
    });

    return Photoswipe;
  })();

  theme.Collection = (function () {
    function Collection(container) {
      this.container = container;
      this.containerId = container.getAttribute("data-section-id");

      this.init(container);
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function (container) {
        // If container not set, section has been reinitialized.
        // Update this.container to refreshed DOM element
        if (!container) {
          this.container = document.getElementById(this.containerId);
        }
        // console.log("Collection-this" , this )
        this.quickAdd = new theme.QuickAdd(this.container);
        this.quickShop = new theme.QuickShop(this.container);
      },
    });

    return Collection;
  })();

  theme.ImageSlider = (function () {
    function ImageSlider(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageSlider.prototype = Object.assign({}, ImageSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: false,
          prevNextButtons: true,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageSlider;
  })();

  theme.ImageCarousel = (function () {
    function ImageCarousel(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__carousel-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageCarousel.prototype = Object.assign({}, ImageCarousel.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: false,
          prevNextButtons: true,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageCarousel;
  })();

  theme.ReviewsSlider = (function () {
    function ReviewsSlider(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-review__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ReviewsSlider.prototype = Object.assign({}, ReviewsSlider.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: false,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: false,
          autoPlay: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ReviewsSlider;
  })();

  theme.ImagesColumn = (function () {
    function ImagesColumn(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__column-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImagesColumn.prototype = Object.assign({}, ImagesColumn.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: true,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImagesColumn;
  })();

  theme.ImageSlideshow = (function () {
    function ImageSlideshow(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-image__slideshow-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    ImageSlideshow.prototype = Object.assign({}, ImageSlideshow.prototype, {
      init: function (container) {
        var sliderArgs = {
          autoPlay: true,
          pageDots: false,
          cellAlign: "left",
          prevNextButtons: false,
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return ImageSlideshow;
  })();

  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    var storage;
    if (type === "session") {
      storage = window.sessionStorage;
    }
    if (type === "local") {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.Toolkit = (function () {
    function Toolkit(container) {
      this.container = container;
      const sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector(
        "#block-announcement__slider-" + sectionId
      );

      if (!this.slideshow) {
        return;
      }

      this.init(container);
    }

    Toolkit.prototype = Object.assign({}, Toolkit.prototype, {
      init: function (container) {
        var sliderArgs = {
          pageDots: false,
          cellAlign: "left",
          adaptiveHeight: true,
          prevNextButtons: true,
          autoPlay: true,
          pauseAutoPlayOnHover: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      },
    });

    return Toolkit;
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById("RecoverPasswordForm")
        .classList.toggle("hide");
      var loginForm = document
        .getElementById("CustomerLoginForm")
        .classList.toggle("hide");
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById("RecoverPassword");
      if (recoverForm) {
        recoverForm.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        "HideRecoverPasswordLink"
      );
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector(".reset-password-success");

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById("ResetSuccess").classList.remove("hide");
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById("AddressNewForm");
      var addressForms = document.querySelectorAll(".js-address-form");

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll(".js-address-country").forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll(".address-new-toggle").forEach((el) => {
        el.addEventListener("click", function () {
          newAddressForm.classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-edit-toggle").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document
            .getElementById("EditAddress_" + formId)
            .classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-delete").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (
            confirm(
              confirmMessage || "Are you sure you wish to delete this address?"
            )
          ) {
            if (Shopify) {
              Shopify.postLink("/account/addresses/" + formId, {
                parameters: { _method: "delete" },
              });
            }
          }
        });
      });
    }
  };

  /*============================================================================
  Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported("session");
  theme.config.hasLocalStorage = theme.isStorageSupported("local");

  if (theme.config.hasLocalStorage) {
    var recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      theme.recentlyViewedIds = JSON.parse(recentIds);
    }
  }

  /*============================================================================
  Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  theme.initGlobals = function () {
    theme.videoModal();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register("header", theme.Header);

    theme.sections.register("toolkit", theme.Toolkit);
    theme.sections.register("product", theme.Product);
    theme.sections.register("accordion", theme.Accordion);
    theme.sections.register("video-grid", theme.videoGrid);
    theme.sections.register("photoswipe", theme.Photoswipe);
    theme.sections.register("collection", theme.Collection);

    theme.sections.register("image-slider", theme.ImageSlider);
    theme.sections.register("images-column", theme.ImagesColumn);
    theme.sections.register("image-carousel", theme.ImageCarousel);
    theme.sections.register("reviews-slider", theme.ReviewsSlider);

    theme.sections.register("slideshow", theme.ImageSlideshow);

    theme.sections.register("products-slider", theme.ProductSlider);
    theme.sections.register("store-availability", theme.StoreAvailability);
    theme.sections.register("footer", theme.Footer);

    theme.initGlobals();

    if (document.body.classList.contains("template-cart")) {
      var cartPageForm = document.getElementById("CartPageForm");
      if (cartPageForm) {
        var cartForm = new theme.CartForm(cartPageForm);

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            cartForm.buildCart();
          }.bind(this)
        );
        console.log("cart page updated...");
      }
    }

    theme.customerTemplates();

    document.querySelector('.text-link__review')?.addEventListener('click', function(e){
      e.preventDefault();
      let target = this.getAttribute('href');
      document.querySelector(target)?.scrollIntoView();
    });
  });
})();


// =================Cart drawer add on ===================
async function isAddOnProductInCart(productId) {
    try {
      const response = await fetch('/cart.js'); // Fetch the current cart
      const cart = await response.json();
      return cart.items.some(item => item.id == productId); // Check if add on product exists
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return false;
    }
}
async function checkaddon_product(){
  isAddOnProductInCart(document.querySelector(".cart__drawer-form").getAttribute("data-add-on-product")*1).then(isInCart => {
    var add_on_ele =  document.querySelector("add-on-product");
      if (add_on_ele){
        if (isInCart) {
          add_on_ele.classList.add("visually-hidden");  
        } else {
          add_on_ele.classList.remove("visually-hidden");  
        }      
      }          
  });  
}

async function add_on_cart () {
      const add_on_btn =  document.querySelector("add-on-product button.quick-add-btn");
      if (add_on_btn) {
          add_on_btn.addEventListener('click', function(e) {
              cstm_addTo_Cart(event);
          });
      }
      function cstm_addTo_Cart (evt) {
        let button = evt.currentTarget;
        let productId = button.dataset.id;

        var data = {
          items: [
            {
              id: productId,
              quantity: 1,
            },
          ],
        };

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422 || data.status === "bad_request") {
              } else {
                var product = data;
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      product: product,
                    },
                  })
                );
                document.querySelector("add-on-product").classList.add("visually-hidden");  
                // new theme.Drawer("header_minicart", "right").open();
              }
            }.bind(this)
          );
      }

}
add_on_cart ();
checkaddon_product();

document.addEventListener("DOMContentLoaded", function () {
  const stickyButton = document.querySelector('.sticky-add-to-cart-btn button');
  // if (stickyButton) {
  //   stickyButton.addEventListener('click', function () {        
  //     gtag('event', 'sticky_add_to_cart_click', {
  //       event_category: 'engagement',
  //       event_label: 'Sticky Add to Cart Button'
  //     });
  //   });
  // }
  if (stickyButton) {
    stickyButton.addEventListener('click', function (e) {        
    const pro_id = this.getAttribute("data-product-id"); 
      this.classList.add("btn--loading");
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(pro_id),
          quantity: 1
        })
      })
      .then(res => res.json())
      .then(data => {      
        var product = data;
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
            },
          })
        );
        this.classList.remove("btn--loading");
        // console.log("added to cart sucessfully..1");
        new theme.Drawer("header_minicart", "right").open();
      })
      .catch(err => {
        console.error("Error:", err);
      });
      
    });
  }
  
  var native_add =  document.querySelectorAll("[data-add-to-cartss]");
  if (native_add) {
    native_add.forEach(function (add_btn) {
      add_btn.addEventListener("click", function (event) {
        event.preventDefault();                                                                 
        const pro_id = this.getAttribute("data-product-id"); 

        let properties = {};

        if(this.dataset.product1){
          properties["_product_1"] = this.dataset.product1;
        }

        if(this.dataset.product2){
          properties["_product_2"] = this.dataset.product2;
        }

        this.classList.add("btn--loading");
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(pro_id),
            quantity: 1,
            properties: properties
          })
        })
        .then(res => res.json())
        .then(data => {      
          var product = data;
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
              },
            })
          );
          this.classList.remove("btn--loading");
          // console.log("Product Data",product);
          // console.log("Home page Buy now button added to cart");
          // new theme.Drawer("header_minicart", "right").open();

          fetch(`/variants/${product.id}.js`)
          .then(res => res.json())
          .then(variantData => {
            // Merge relevant variant info into the product object
            product.price = variantData.price;
            product.compare_at_price = variantData.compare_at_price;

            addToCartPopup_fn(product);
          })
          .catch(err => {
            console.error("Error fetching variant details:", err);
            addToCartPopup_fn(product); // fallback
          });
        })
        .catch(err => {
          console.error("Error:", err);
        });            
    
      });
    });
  }


  // ===================== End tracking code for SATC ========================
  // var elems = document.querySelectorAll(".video-list-slider .main-carousel");
  // if(elems.length){
  //   elems.forEach((elem)=>{
  //     if (elem) {
  //       var flkty_slider = new Flickity(elem, {
  //         wrapAround: true,
  //         cellAlign:'left',
  //         pageDots: true,
  //         autoPlay: true
  //       });

  //       flkty_slider.on('ready', function() {
  //         updateDotPagination(flkty_slider);
  //       });

  //       // run every time the slide changes
  //       flkty_slider.on('change', function() {
  //         updateDotPagination(flkty_slider);
  //       });
  //     }
  //   });
  // }

  var elems = document.querySelectorAll(".video-list-slider .main-carousel");

  if (elems.length) {
    elems.forEach((elem) => {
      if (elem) {
        var flkty_slider = new Flickity(elem, {
          wrapAround: true,
          cellAlign: 'left',
          pageDots: true,
          autoPlay: true
        });

        // Update pagination on ready
        flkty_slider.on('ready', function () {
          updateDotPagination(flkty_slider);
        });

        // Update pagination on slide change
        flkty_slider.on('change', function () {
          updateDotPagination(flkty_slider);
        });

        // Fix: handle video load inside this slider only
        var videos = elem.querySelectorAll("video");
        videos.forEach((video) => {
          video.addEventListener("loadedmetadata", function () {
            // Resize Flickity when video dimensions are available
            flkty_slider.resize();
          });
        });
      }
    });
  }

  ///image gallery slider
  var elem = document.querySelector(".image-gallery .image-gallery-grid");
  if (elem) {
    var flkty_slider = new Flickity(elem, {
      wrapAround: true,
      cellAlign:'left',
      pageDots: false,
      autoPlay: true
    });

    flkty_slider.on('ready', function() {
      updateDotPagination(flkty_slider);
    });

    // run every time the slide changes
    flkty_slider.on('change', function() {
      updateDotPagination(flkty_slider);
    });

  }; 
  
  ///story images gallery slider
  var elem = document.querySelector(".story-slider .carousel");
  if (elem) {
    var flkty_slider = new Flickity(elem, {
      wrapAround: true,
      cellAlign:'left',
      pageDots: true,
      autoPlay: false
    });
  }; 
  
  ///mobile costume idea images slider
  if (window.screen.width < 750) {
    var elem = document.querySelectorAll(".costume-images-grid");
    if (elem) {
      elem.forEach(function (params) {
        var flkty_slider = new Flickity(params, {
        wrapAround: true,
        cellAlign:'left',
        pageDots: false,
        autoPlay: true
        });
      });
    } 
  }
  
 // ================video slider  fun ===========================
  // document.querySelectorAll(".video-list-slider .carousel-cell").forEach((container) => {
  //   let video = container.querySelector("video");
  //   let playButton = container.querySelector(".play-icon");

  //   playButton.addEventListener("click", function (event) {

  //     event.preventDefault(); // Prevent default link behavior
  //     // Pause all other videos before playing the selected one
  //     document.querySelectorAll(".video-list-slider video").forEach((vid) => {
  //       if (vid !== video) {
  //         vid.pause();
  //         vid.controls = false ;
  //         vid.closest(".carousel-cell").querySelector(".play-icon").classList.remove("hide");
  //       }
  //     });

  //     if (video.paused) {
  //       video.play();
  //       video.controls = true ;
  //       playButton.classList.add("hide")
  //     } else {
  //       video.pause();
  //       video.controls = false ;
  //       playButton.classList.remove("hide")
  //     }
      
  //   });
  //   video.addEventListener("ended", function () {
  //     video.controls = false ;
  //     playButton.classList.remove("hide")
  //   });
  // });

  // -d start of adding mp4/utube video logic

    (function () {
      var ytPlayers = {};

      // ── Hook into the theme's existing youTubeReady event ──────────
      // NEVER overwrite window.onYouTubeIframeAPIReady — theme already uses it
      function initVideoSliderPlayers() {
        document
          .querySelectorAll(".video-list-slider .carousel-cell iframe.youtube-player")
          .forEach(function (iframe, index) {
            // Assign unique ID if missing
            if (!iframe.id) iframe.id = "yt-slider-" + index;

            // Force enablejsapi if somehow missing
            if (!iframe.src.includes("enablejsapi=1")) {
              iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
            }

            ytPlayers[iframe.id] = new YT.Player(iframe.id, {
              events: {
                onStateChange: function (event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    pauseAllExcept(null, iframe.id);
                  }
                },
              },
            });
          });
      }

      // ── Central pause function ─────────────────────────────────────
      function pauseAllExcept(activeMP4, activeYTId) {
        // Pause all MP4s except active
        document
          .querySelectorAll(".video-list-slider .carousel-cell video")
          .forEach(function (vid) {
            if (vid !== activeMP4) {
              vid.pause();
              vid.controls = false;
              var btn = vid.closest(".carousel-cell") &&
                        vid.closest(".carousel-cell").querySelector(".play-icon");
              if (btn) btn.classList.remove("hide");
            }
          });

        // Pause all YT players except active
        Object.keys(ytPlayers).forEach(function (id) {
          if (id !== activeYTId) {
            var player = ytPlayers[id];
            if (player && typeof player.pauseVideo === "function") {
              try { player.pauseVideo(); } catch (e) {}
            }
          }
        });
      }

      // ── MP4 play button logic ──────────────────────────────────────
      document
        .querySelectorAll(".video-list-slider .carousel-cell")
        .forEach(function (container) {
          var video = container.querySelector("video");
          var playButton = container.querySelector(".play-icon");

          if (!video || !playButton) return;

          playButton.addEventListener("click", function (event) {
            event.preventDefault();

            if (video.paused) {
              pauseAllExcept(video, null);
              video.play();
              video.controls = true;
              playButton.classList.add("hide");
            } else {
              video.pause();
              video.controls = false;
              playButton.classList.remove("hide");
            }
          });

          video.addEventListener("ended", function () {
            video.controls = false;
            playButton.classList.remove("hide");
          });
        });

      // ── Wait for theme's youTubeReady event ───────────────────────
      if (theme.config.youTubeReady) {
        // YT already ready (rare but possible)
        initVideoSliderPlayers();
      } else {
        document.addEventListener("youTubeReady", function () {
          initVideoSliderPlayers();
        });
      }

    })();

    // end of logic

  function slider_grid_fullheight() {
    const productItems = document.querySelectorAll(".product-slider-inner .grid-product");
    productItems.forEach(item => {
      item.style.height = "100%";
    });
  }
    setTimeout(() => {     
      slider_grid_fullheight();
    }, 3000);
  
    
// const videos = document.querySelectorAll(".video-list-slider video");
  let currentIndex = 0;
  function playNextVideo() {
    if (videos.length === 0) return;
    // Play current video
    let currentVideo = videos[currentIndex];
    currentVideo.play();

    // Move to the next video after 3 seconds
    setTimeout(() => {
      currentIndex = (currentIndex + 1) % videos.length; // Loop back after last video
      playNextVideo();
    }, 3000);
  }


 // playNextVideo(); 
// ====================================================
  let touchStartX = 0;
  let touchEndX = 0;

  function handleSwipe() {
    // console.log("touchStartX", touchStartX, "touchEndX", touchEndX)
    if (touchStartX - touchEndX > 50 && document.querySelector("html").classList.contains("js-drawer-open-left")) {            
             document.querySelector("#mobile-navigation .js-drawer-close").click();      
    }
    if(touchEndX - touchStartX > 50 && document.querySelector("html").classList.contains("js-drawer-open-right")){      
                document.querySelector("#header_minicart .js-drawer-close").click();    
    }
  }

  document.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  });

  document.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });  

// ================
  const cstm_btn_cart = document.querySelector(".custom-cart-icon-wrap");
  if(cstm_btn_cart){
      cstm_btn_cart.addEventListener("click", function() {
          document.querySelector("[data-header-cart-trigger]").click();
      });    
  }

// ======================== PDP page scroll ===================
if (location.href.includes("judgeme_product_reviews")) { 
        setTimeout(() => {
        const review_a = document.querySelector(".jdgm-write-rev-link");
        if (review_a){review_a.click();}  
        }, 3000);
}
  
 if (location.href.includes("customer_posted=true")) {
  const interval = setInterval(() => {
    const footer = document.querySelector(".section-footer__inner");
    const instaFeed = document.querySelector("#insta-feed");

    if (footer && instaFeed && instaFeed.offsetHeight > 0) {
      const footerTop = footer.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: footerTop,
        behavior: "smooth"
      });

      clearInterval(interval); // Stop checking after scroll
    }
  }, 1000); // Check every 300ms
}

// ========================== End of the DOM ==========================
});

// function updateDotPagination(){
//   document.querySelectorAll("[data-product-images] .flickity-page-dots").forEach(dots => { 
//     if(dots.children.length<10) return;
//     let currentDot = dots.querySelector(".dot.is-selected");
//     let currentIndex = -1;
//     let lastIndex = dots.children.length - 1;
//     if(currentDot) currentIndex = [...currentDot.parentNode.children].indexOf(currentDot);
//     else return;
   
//     dots.querySelectorAll( ".dot" ).forEach( (dot, index) => {
//       if ( index==0 || index==dots.children.length-1 ) return;
//       if ( index == currentIndex ) { dot.classList.remove("dot--gap"); return; } 
//       dot.classList.add("dot--gap"); 
//     } );
   
//     const span = 3;
//     dots.querySelectorAll( ".dot" ).forEach( (dot, index) => {
//       if ( !dot.classList.contains("dot--gap") ) return;
//       if( index < currentIndex ){ 
//         if( currentIndex < span || ( lastIndex - currentIndex <= span && lastIndex - index <= span )  ) {  
//           dot.classList.remove("dot--gap");
//           return; 
//         } 
//         if( currentIndex - index < 2 ) dot.classList.remove("dot--gap"); 
//       } else {
//         if( lastIndex - currentIndex < span || ( currentIndex <= span && index <= span ) ) { 
//           dot.classList.remove("dot--gap"); 
//           return; 
//         } 
//         if( index - currentIndex < 2 ) dot.classList.remove("dot--gap"); 
//       }
//     });
//   });
// }

function updateDotPagination(target) {
  // console.log("Target",target);
  let dotsContainer = null;

  // Case 1: Flickity instance passed
  if (target && target.pageDots) {
    dotsContainer = target.pageDots.holder; // <ol> wrapper element
  }

  // Case 2: DOM container passed
  else if (target instanceof Element) {
    dotsContainer = target.querySelector(".flickity-page-dots");
  }

  if (!dotsContainer) {
    console.log("No dots found for", target);
    return;
  }

  let currentDot = dotsContainer.querySelector(".dot.is-selected");
  if (!currentDot) return;

  // console.log("current DOT:", currentDot);

  let currentIndex = [...dotsContainer.children].indexOf(currentDot);
  let lastIndex = dotsContainer.children.length - 1;

  // Reset all to gap except first/last/current
  dotsContainer.querySelectorAll(".dot").forEach((dot, index) => {
    if (index === 0 || index === lastIndex || index === currentIndex) {
      dot.classList.remove("dot--gap");
    } else {
      dot.classList.add("dot--gap");
    }
  });

  const span = 3;
  dotsContainer.querySelectorAll(".dot").forEach((dot, index) => {
    if (!dot.classList.contains("dot--gap")) return;

    if (index < currentIndex) {
      if (currentIndex < span || (lastIndex - currentIndex <= span && lastIndex - index <= span)) {
        dot.classList.remove("dot--gap");
      } else if (currentIndex - index < 2) {
        dot.classList.remove("dot--gap");
      }
    } else {
      if (lastIndex - currentIndex < span || (currentIndex <= span && index <= span)) {
        dot.classList.remove("dot--gap");
      } else if (index - currentIndex < 2) {
        dot.classList.remove("dot--gap");
      }
    }
  });
}
function formatMoneyNoTrailing(amount) {
        let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
        return formatted.replace(/(\.00|,00)$/, '');
}




// document.addEventListener("cart:updated", function (event) {
//   updateExtendedWarranty();
//   updateCompareTotal();

//   if (event.detail && event.detail.cart) {
//     const cart = event.detail.cart;

//     updateFreeShippingUI(cart.total_price);
//     updateCartSavingsUI(cart);

//   } else {
//     // fallback (safe)
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateFreeShippingUI(cart.total_price);
//         updateCartSavingsUI(cart);
//       });
//   }
// });


document.addEventListener('cart:updated', function (event) {
  if (!event.detail || !event.detail.cart) return;

  const cart = event.detail.cart;

  /* =========================
     CART PAGE LOGIC
  ========================== */
  updateExtendedWarranty();
  setTimeout(()=>{
    updateCompareTotal();
  },1000);
  

  updateCartPageOrderDiscount(cart); // ✅ FIXED

  toggleOrderDiscountVisibility();

  updateFreeShippingUI(cart.total_price);
});





  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('.block-mincart .cart__footer .cart__item-row.payment-buttons .btn-cart__checkout');
    if (!checkoutBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // loading class add
    checkoutBtn.classList.add('btn--loading');

    // optional: disable button to prevent double click
    checkoutBtn.setAttribute('disabled', 'disabled');

    // small delay so loading animation shows
    setTimeout(() => {
      window.location.href = '/checkout';
    }, 300);
  });





function updateCartCount(count) {
  const countElem = document.querySelector(".cart__item-sub.cart__item--subtotal .drawer-item-count");
  if (countElem) {
    countElem.textContent = "(" + count + (count === 1 ? " item" : " items") + ")";
  }
}

function handleCartUpdate(event) {
  if (event && event.detail && event.detail.cart) {
    const cart = event.detail.cart;
    updateFreeShippingUI(cart.total_price);
    updateCompareTotal();

  } else {
    // fallback (safe)
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateFreeShippingUI(cart.total_price);
        updateCompareTotal();
      });
  }
}



// document.addEventListener("ajaxProduct:added", function(event) {

//       fetch('/cart.js')
//         .then(res => res.json())
//         .then(cart => {
//           setTimeout(() => {
//         fetch('/cart.js')
//           .then(res => res.json())
//           .then(cart => {
//             updateFreeShippingUI(cart.total_price);
//             updateCartCount(cart.item_count);
//           });
//       }, 300); // 👈 delay compulsory

//       //  Find warranties whose _related_product is NOT in main products anymore
//       var saving = 0;

//       cart.items.forEach(item => {
//         // For displaying aving price of all the items
//         let variantId = item.id; 
      
//         fetch(`/variants/${variantId}.js`)
//           .then(res => res.json())
//           .then(variant => {
//             if (variant.compare_at_price > item.original_price) {
//               // calculate per-unit saving (still in cents)
//               let line_saving = (variant.compare_at_price - item.original_price) * item.quantity;
//               saving += line_saving; // accumulate
//             }

//             let formattedSaving = formatMoneyNoTrailing(saving);
//             let savingEl = document.querySelector(".cart__footer .block-saving__amount");
             
//             if (savingEl) {
//               savingEl.textContent = formattedSaving;          // text update (je tame karto hata)
//               savingEl.setAttribute("cus-discount", formattedSaving); // ✅ SAME value attribute ma
//             }

//           })
//           .catch(err => console.error("Variant fetch error:", err));
//       });
//       function formatMoneyNoTrailing(amount) {
//         let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
//         return formatted.replace(/(\.00|,00)$/, '');
//       }
//         updateCompareTotal();
//     });

//     let product = event.detail.product;
//     if (!product || !product.id) return;

//     // Wait a moment for the cart DOM to refresh
//     setTimeout(() => {
//       // Find warranty button for this specific product in cart
//       let warrantyBtn = document.querySelector(
//         `.cart__item_wrp[data-id="${product.id}"] .extended-warranty[data-extended-submit]`
//       );

//       if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
//         // Simulate click to use existing logic
//         warrantyBtn.click();
//         console.log("warrantyBtn",warrantyBtn);
//       }
//     }, 2000);

//      updateExtendedWarranty();
   

//      if (event && event.detail && event.detail.cart) {
//     const cart = event.detail.cart;
//     updateFreeShippingUI(cart.total_price);
//   } else {
//     // fallback (safe)
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateFreeShippingUI(cart.total_price);
//       });
//   }

// });

document.addEventListener("ajaxProduct:added", function (event) {
  // Wait for Shopify cart to fully update
  setTimeout(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        /* =============================
           FREE SHIPPING + COUNT
        ============================== */
        updateFreeShippingUI(cart.total_price);
        updateCartCount(cart.item_count);
        updateCompareTotal();

        /* =============================
           SAVING CALCULATION
        ============================== */
        let saving = 0;
        let processed = 0;

        cart.items.forEach(item => {
          fetch(`/variants/${item.id}.js`)
            .then(res => res.json())
            .then(variant => {
              if (variant.compare_at_price > item.original_price) {
                saving +=
                  (variant.compare_at_price - item.original_price) *
                  item.quantity;
              }
            })
            .finally(() => {
              processed++;

              if (processed === cart.items.length) {
                let formattedSaving = formatMoneyNoTrailing(saving);
                let savingEl = document.querySelector(".cart__footer .block-saving__amount");

                if (savingEl) {
                  savingEl.textContent = formattedSaving;
                  savingEl.setAttribute("cus-discount", formattedSaving);
                }
              }
            });
        });

      });
  }, 300); // IMPORTANT delay

  /* =============================
     WARRANTY AUTO ADD
  ============================== */
  const product = event.detail?.product;
  if (!product?.id) return;

  setTimeout(() => {
    let warrantyBtn = document.querySelector(
      `.cart__item_wrp[data-id="${product.id}"] .extended-warranty[data-extended-submit]`
    );

    if (warrantyBtn && warrantyBtn.dataset.inCart !== "true") {
      warrantyBtn.click();
    }
  }, 2000);

  updateExtendedWarranty();
});

/* =============================
   Helper
============================== */
function formatMoneyNoTrailing(amount) {
  let formatted = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
  return formatted.replace(/(\.00|,00)$/, '');
}

document.addEventListener("cart:updated", function (event) {
  let cart = event.detail.cart;

  const item_count = cart.item_count;
  const countElem = document.querySelector(".cart__item-sub.cart__item--subtotal .drawer-item-count");
  if (countElem) {
    countElem.textContent = "(" + item_count + (item_count === 1 ? " item" : " items") + ")";
  }

  // Loop through each upsell form on the page
  document.querySelectorAll("[data-upsell-selector] form").forEach(form => {
    let addBtn = form.querySelector(".add-upsell-product");
    if (!addBtn) return;

    // Get variant ID from hidden input
    let variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    // Check if that variant is still in the cart
    let stillInCart = cart.items.some(item => item.id == variantId);

    if (!stillInCart) {
      // Re-enable button
      addBtn.disabled = false;
      addBtn.classList.remove("btn--loading");
      // console.log("Product added successfully..3");
      const btnText = addBtn.querySelector("[data-upsell-text]").getAttribute("data-text");
      addBtn.querySelector("[data-upsell-text]").innerText = btnText; 
      // Make sure to have `theme.strings.upgrade` in your translations
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  updateCompareTotal();

  if (document.body.classList.contains("template-index")) {
    new theme.QuickAdd(document);
  }

  const form = document.querySelector(".subscribe-form");
  const closeBtn = document.querySelector(".subscribe-form .decline-offer");

  const COOKIE_NAME = "klaviyo_subscribe_hide_24h";
  const HIDE_DURATION_HOURS = 24;

  function setCookie(name, value, hours) {
    const d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie =
      name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const cname = name + "=";
    const cookies = decodeURIComponent(document.cookie).split(";");

    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length);
      }
    }
    return "";
  }

  // Hide initially
  form?.classList.add("hide");

  // Show after 8 seconds only if cookie does not exist
  if (getCookie(COOKIE_NAME) !== "true") {
    setTimeout(() => {
      form?.classList.remove("hide");
    }, 8000);
  }

  // Close popup and set cookie
  closeBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    form?.classList.add("hide");
    setCookie(COOKIE_NAME, "true", HIDE_DURATION_HOURS);
  });
});

document.addEventListener("click", function (e) {
  const anchor = e.target.closest("a[href^='#']");
  if (!anchor) return;

  const targetId = anchor.getAttribute("href").substring(1);
  const targetBlock = document.getElementById(targetId);

  if (!targetBlock) return;

  e.preventDefault();

  // Scroll to section
  targetBlock.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });

  // Find accordion header inside this block
  const header = targetBlock.querySelector(".block-title");

  if (header && !header.classList.contains("open")) {
    setTimeout(() => {
      header.click();
    }, 400); // small delay so scroll completes first
  }
});

document.body.addEventListener('click',(event)=>{
  let click_btn = event.target;
  if(click_btn.closest('.featured-product-list')){
    if(click_btn.closest('.featured-product-list')){
      if(typeof updateDotPagination == 'function'){
        updateDotPagination(click_btn.closest('.featured-product-list'));
      }
    }
  }
})